export var headers = {
	"Project-Id-Version": "oxdocuments",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "",
	"PO-Revision-Date": "2024-12-01 15:08-0600",
	"Last-Translator": "Timothy Friesen <timothy@workshop-chapina.com>",
	Language: "en_GB",
	"Language-Team": "English <kde-i18n-doc@kde.org>",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bit",
	"Plural-Forms": "nplurals=2; plural=(n > 1);",
	"MIME-Version": "1.0",
	"X-Generator": "Lokalize 21.12.3"
};
export default {
	headers: headers,
	"\u0000The document was not loaded successfully. Download is not possible.\u0001": [
	"The document was not loaded successfully. Download is not possible."
],
	"\u0000The browser has blocked a pop-up window. Please enable pop-ups for download.\u0001": [
	"The browser has blocked a pop-up window. Please enable pop-ups for download."
],
	"\u0000The server does not answer the request.\u0001": [
	"The server did not answer the request."
],
	"\u0000Download Error\u0001": [
	"Download Error"
],
	"\u0000The document was not loaded successfully. Send as mail is not possible.\u0001": [
	"The document was not loaded successfully. Send as e-mail is not possible."
],
	"\u0000The server does not answer the request. Send as mail is not possible.\u0001": [
	"The server did not answer the request. Send as e-mail is not possible."
],
	"\u0000Empty document\u0001": [
	"Empty document"
],
	"\u0000Non convertible document content\u0001": [
	"Non-convertible document content"
],
	"\u0000This document is empty. Do you want to send this document as email content?\u0001": [
	"This document is empty. Do you want to send this document as e-mail content?"
],
	"\u0000This document contains elements that cannot be sent in an email. Do you want to send this document as email content?\u0001": [
	"This document contains elements that cannot be sent in an e-mail. Do you want to send this document as e-mail content?"
],
	"\u0000Please use the most recent version of Google Chrome for full support.\u0001": [
	"Please use the most recent version of Google Chrome for full support."
],
	"\u0000Please use the most recent version of Safari for full support.\u0001": [
	"Please use the most recent version of Safari for full support."
],
	"\u0000Please use the most recent version of either Chrome, Firefox, Internet Explorer or Safari.\u0001": [
	"Please use the most recent version of either Chrome, Firefox, Internet Explorer or Safari."
],
	"app\u0000Text\u0001": [
	"Text"
],
	"app\u0000Spreadsheet\u0001": [
	"Spreadsheet"
],
	"app\u0000Presentation\u0001": [
	"Presentation"
],
	"\u0000Cannot synchronize while offline. Please reload the document as soon as you are online again.\u0001": [
	"Cannot synchronise while offline. Please reload the document as soon as you are online again."
],
	"\u0000Cannot synchronize while offline. You have changes which could not be saved. Please try to copy the whole content into the clipboard and paste it into a new document as soon as you are online again\u0001": [
	"Cannot synchronise while offline. You have changes which could not be saved. Please try to copy the whole content into the clipboard and paste it into a new document as soon as you are online again"
],
	"\u0000The document could not be loaded. The server connection was lost during loading the document. If the problem only persists with the same document it can be an error in the document.\u0001": [
	"The document could not be loaded. The server connection was lost while loading the document. If the problem only persists with the same document it could be an error in the document."
],
	"\u0000Due to a server connection error the editor switched to read-only mode. Please reload the document.\u0001": [
	"Due to a server connection error the editor switched to read-only mode. Please reload the document."
],
	"\u0000Connection to the server hosting the document has been lost. Please reload the document.\u0001": [
	"Connection to the server hosting the document has been lost. Please reload the document."
],
	"\u0000Synchronization not possible, because an unknown error occured. Please reload the document for further usage.\u0001": [
	"Synchronisation not possible, because an unknown error occured. Please reload the document for further usage."
],
	"\u0000Synchronization not possible, because the server was not able to process the synchronization request. Please reload the document.\u0001": [
	"Synchronisation not possible, because the server was not able to process the synchronisation request. Please reload the document."
],
	"\u0000Synchronization not possible, because the server is not able to synchronize this document. Please reload the document for further usage.\u0001": [
	"Synchronisation not possible, because the server is not able to synchronise this document. Please reload the document for further usage."
],
	"\u0000You are not the editor of the document anymore. Synchronization is not possible, please reload the document.\u0001": [
	"You are no longer the editor of the document. Synchronisation is not possible, please reload the document."
],
	"\u0000Connection to server was lost. Please reopen the document to acquire edit rights.\u0001": [
	"Connection to server was lost. Please reopen the document to acquire edit rights."
],
	"\u0000An unrecoverable error occurred while modifying the document.\u0001": [
	"An unrecoverable error occurred while modifying the document."
],
	"\u0000An unrecoverable error occurred while loading the document.\u0001": [
	"An unrecoverable error occurred while loading the document."
],
	"\u0000Siri is not supported as input method. Please do not use to input text.\u0001": [
	"Siri is not supported as an input method. Please do not use it to input text."
],
	"\u0000The document could not be loaded. The server is currently too busy. Please try again later.\u0001": [
	"The document could not be loaded. The server is currently too busy. Please try again later."
],
	"\u0000A server component is not working. Please contact the server administrator.\u0001": [
	"A server component is not working. Please contact the server administrator."
],
	"\u0000The document is protected with a password.\u0001": [
	"The document is protected with a password."
],
	"\u0000Connection to the server has been lost. Please reload the document.\u0001": [
	"Connection to the server has been lost. Please reload the document."
],
	"\u0000The server detected a synchronization problem with your client. Please reload the doument.\u0001": [
	"The server detected a synchronisation problem with your client. Please reload the doument."
],
	"\u0000The document could not be loaded, because the server could not process our request successfully. Please try again later.\u0001": [
	"The document could not be loaded, because the server could not process our request successfully. Please try again later."
],
	"\u0000The document could not be loaded, because the server is busy saving the requested document. Please try again later.\u0001": [
	"The document could not be loaded, because the server is busy saving the requested document. Please try again later."
],
	"\u0000An unknown server error occurred while processing your request. Please retry again later.\u0001": [
	"An unknown server error occurred while processing your request. Please retry later."
],
	"\u0000The server we are connected to is going down. To save your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The server we are connected to is going down. To save your latest changes, please copy the complete content into the clipboard and paste it into a new document."
],
	"\u0000The server we are connected to is going down. The document cannot be changed anymore. Please try to reload the document later.\u0001": [
	"The server we are connected to is going down. The document can no longer be changed. Please try to reload the document later."
],
	"\u0000The server we are connected to is not available. The document cannot be changed anymore. Please try to reload the document later.\u0001": [
	"The server we are connected to is not available. The document cannot be changed. Please try to reload the document later."
],
	"\u0000The server we are connected to is not available. To save your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The server we are connected to is not available. To save your latest changes, please copy the complete content into the clipboard and paste it into a new document."
],
	"\u0000Your session is invalid and relogin failed. Please login again and to save your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Your session is invalid and re-login failed. Please login again and to save your latest changes, please copy the complete content into the clipboard and paste it into a new document."
],
	"\u0000Connection to server was lost. Switched to read-only mode.\u0001": [
	"Connection to server was lost. Switched to read-only mode."
],
	"\u0000The server does not answer our action requests. Maybe the connection is unstable or the server side has problems.\u0001": [
	"The server did not answer our action requests. Maybe the connection is unstable or the server side has problems."
],
	"\u0000You do not have permissions to change this document.\u0001": [
	"You do not have the permissions to change this document."
],
	"\u0000Connection to server was lost. Please wait, trying to synchronize to enable edit mode.\u0001": [
	"Connection to server was lost. Please wait, trying to synchronise to enable edit mode."
],
	"\u0000Connection to server was lost. Enable client to acquire edit rights.\u0001": [
	"Connection to server was lost. Enable client to acquire edit rights."
],
	"\u0000The document cannot be changed, because the format is not editable. To create an editable document, please use \"save as\" or copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The document cannot be changed, because the format is not editable. To create an editable document, please use \"save as\" or copy the complete content into the clipboard and paste it into a new document."
],
	"\u0000Your session is invalid. Please login again.\u0001": [
	"Your session is invalid. Please login again."
],
	"\u0000The server detected a synchronization problem with your client. To save your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The server detected a synchronisation problem with your client. To save your latest changes, please copy the complete content into the clipboard and paste it into a new document."
],
	"\u0000A previous session failure could be resolved but your latest changes could not be saved. Please copy the complete content to the clipboard and paste it into a new document.\u0001": [
	"A previous session failure could be resolved but your latest changes could not be saved. Please copy the complete content to the clipboard and paste it into a new document."
],
	"\u0000The server detected a problem with your document. To save your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The server detected a problem with your document. To save your last changes, please copy the complete contents into the clipboard and paste it into a new document."
],
	"\u0000A conflict has occurred during simultaneous editing. To solve this conflict the document is now reloaded.\u0001": [
	"A conflict has occurred during simultaneous editing. To solve this conflict the document has been reloaded."
],
	"\u0000The document was modified by an unsupported action. To solve this problem the document is now reloaded.\u0001": [
	"The document was modified by an unsupported action. To solve this problem the document has been reloaded."
],
	"\u0000The document has been moved to a different folder. To solve this problem the document is now reloaded for further usage.\u0001": [
	"The document has been moved to a different folder. To solve this problem the document has been reloaded for further usage."
],
	"\u0000The document has been moved to a different folder. You have lost permissions to change this document. To save your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The document has been moved to a different folder. You have lost permissions to change this document. To save your latest changes, please copy the complete content into the clipboard and paste it into a new document."
],
	"\u0000The document has been deleted. To save your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The document has been deleted. To save your latest changes, please copy the complete content into the clipboard and paste it into a new document."
],
	"\u0000The document could not be saved. Your quota limit has been reached. Please free up storage space.\u0001": [
	"The document could not be saved. Your quota limit has been reached. Please free up storage space."
],
	"\u0000The document could not be written, because the document could not be found. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The document could not be written because the document could not be found. To save your work, please copy the complete contents into the clipboard and paste them into a new document."
],
	"\u0000The document could not be read, because you lost read permissions. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The document could not be read because you lost read permissions. To save your work, please copy the complete contents into the clipboard and paste them into a new document."
],
	"\u0000The document could not be written, because you lost write permissions. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The document could not be written because you lost write permissions. To save your work, please copy the complete contents into the clipboard and paste them to a new document."
],
	"\u0000The document could not be saved. The server has not enough memory. To save your last changes, please copy the complete content into the clipboard and paste it into a new document. If you close the document, the last consistent version will be restored.\u0001": [
	"The document could not be saved. The server does not have enough memory. To save your latest changes, please copy the complete contents into the clipboard and paste them into a new document. If you close the document, the last consistent version will be restored."
],
	"\u0000The document could not be saved. The document is protected by a lock. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The document could not be saved. The document is protected by a lock. To save your work, please copy the complete contents into the clipboard and paste it into a new document."
],
	"\u0000The document is in an inconsistent state. To save your work, please copy the complete content into the clipboard and paste it into a new document. Furthermore the last consistent document was restored.\u0001": [
	"The document is in an inconsistent state. To save your work, please copy the complete contents into the clipboard and paste them into a new document. Furthermore, the last consistent document was restored."
],
	"\u0000The document was saved successfully, but a backup copy could not be created. You do not have the permission to create a file in the folder.\u0001": [
	"The document was saved successfully, but a backup copy could not be created. You do not have the permission to create a file in the folder."
],
	"\u0000The document was saved successfully, but a backup copy could not be created. You do not have the correct permissions in the folder.\u0001": [
	"The document was saved successfully, but a backup copy could not be created. You do not have the correct permissions in the folder."
],
	"\u0000The document was saved successfully, but a backup copy could not be created. Your quota limit has been reached. Please free up storage space. \u0001": [
	"The document was saved successfully, but a backup copy could not be created. Your quota limit has been reached. Please free up storage space. "
],
	"\u0000The document was saved successfully, but a backup copy could not be created.\u0001": [
	"The document was saved successfully, but a backup copy could not be created."
],
	"\u0000The document was saved successfully, but a backup copy could not be written due to a lock protection.\u0001": [
	"The document was saved successfully, but a backup copy could not be written due to a lock protection."
],
	"\u0000The document is inconsistent and the server was not able to create a backup file. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The document is inconsistent and the server was not able to create a backup file. To save your work, please copy the complete contents into the clipboard and paste them into a new document."
],
	"\u0000The document cannot be saved, because the server is too busy. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The document cannot be saved, because the server is too busy. To save your work, please copy the complete content into the clipboard and paste it into a new document."
],
	"\u0000The document was only saved with some of your changes. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The document was only saved with some of your changes. To save your work, please copy the complete content into the clipboard and paste it into a new document."
],
	"\u0000The document cannot be saved because a new version has been uploaded. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The document cannot be saved because a new version has been uploaded. To save your work, please copy the complete contents into the clipboard and paste it into a new document."
],
	"\u0000Could not create document because the necessary conversion of the file failed.\u0001": [
	"Could not create document because the necessary conversion of the file failed."
],
	"\u0000Could not create document because the necessary template file could not be read.\u0001": [
	"Could not create document because the necessary template file could not be read."
],
	"\u0000Could not create document because the default template file could not be read.\u0001": [
	"Could not create document because the default template file could not be read."
],
	"\u0000Could not create document due to missing folder permissions.\u0001": [
	"Could not create document due to missing folder permissions."
],
	"\u0000Could not create document because the allowed quota is reached. Please delete some items in order to create new ones.\u0001": [
	"Could not create document because the allowed quota has been reached. Please delete some items in order to create new ones."
],
	"\u0000Could not create document because the template file could not be found.\u0001": [
	"Could not create document because the template file could not be found."
],
	"\u0000Could not create document, because the template file is corrupt.\u0001": [
	"Could not create document, because the template file is corrupt."
],
	"\u0000Saving the document to a new file failed, because the source document could not be found.\u0001": [
	"Saving the document to a new file failed because the source document could not be found."
],
	"\u0000Saving the document to a new file failed, because you lost read permissions on the source document. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Saving the document to a new file failed, because you lost read permissions on the source document. To save your work, please copy the complete contents into the clipboard and paste it into a new document."
],
	"\u0000Saving the document to a new file failed, because you have no write permissions.\u0001": [
	"Saving the document to a new file failed, because you have no write permissions."
],
	"\u0000The new document could not be saved, because your default folder is unknown.\u0001": [
	"The new document could not be saved, because your default folder is unknown."
],
	"\u0000The new document could not be saved, because your quota has been reached.\u0001": [
	"The new document could not be saved, because your quota has been reached."
],
	"\u0000The new document could not be saved, because you do not have permissions to create a file in the folder.\u0001": [
	"The new document could not be saved, because you do not have permissions to create a file in the folder."
],
	"\u0000The new document could not be saved, because an unknown error occurred.\u0001": [
	"The new document could not be saved, because an unknown error occurred."
],
	"\u0000The document cannot be found. Saving the document is not possible. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The document cannot be found. Saving the document is not possible. To save your work, please copy the complete contents into the clipboard and paste them into a new document."
],
	"\u0000The document could not be saved, because you lost read permissions. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The document could not be saved because you lost read permissions. To save your work, please copy the complete contents into the clipboard and paste them into a new document."
],
	"\u0000The document could not be saved, because you lost write permissions. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The document could not be saved because you lost write permissions. To save your work, please copy the complete contents into the clipboard and paste them into a new document."
],
	"\u0000The server detected a synchronization problem with all clients of this document. Please reload the document.\u0001": [
	"The server detected a synchronisation problem with all clients of this document. Please reload the document."
],
	"\u0000Renaming the document failed.\u0001": [
	"Renaming the document failed."
],
	"\u0000Renaming the document failed. The file name contains invalid characters\u0001": [
	"Renaming the document failed. The file name contains invalid characters"
],
	"\u0000Renaming the document failed. The storage containing the file does not support renaming a file.\u0001": [
	"Renaming the document failed. The storage containing the file does not support renaming a file."
],
	"\u0000Please wait. The document will be renamed and must be reloaded.\u0001": [
	"Please wait. The document will be renamed and must be reloaded."
],
	"\u0000An error occurred while loading the document.\u0001": [
	"An error occurred while loading the document."
],
	"\u0000The document could not be loaded, because the document data could not be read in time. Please try again later.\u0001": [
	"The document could not be loaded, because the document data could not be read in time. Please try again later."
],
	"\u0000This document exceeds the size and complexity limits.\u0001": [
	"This document exceeds the size and complexity limits."
],
	"\u0000This document exceeds the text document size and complexity limits.\u0001": [
	"This document exceeds the text document size and complexity limits."
],
	"\u0000This document exceeds the presentation size and complexity limits.\u0001": [
	"This document exceeds the presentation size and complexity limits."
],
	"\u0000This document exceeds the spreadsheet size and complexity limits.\u0001": [
	"This document exceeds the spreadsheet size and complexity limits."
],
	"\u0000This document exceeds the number of sheets limit.\u0001": [
	"This document exceeds the number of sheets limit."
],
	"\u0000The engine used for calculating formulas is not available.\u0001": [
	"The engine used for calculating formulas is not available."
],
	"\u0000This document could not be loaded, because it was created with a version of Microsoft Office prior to Office 2007.\u0001": [
	"This document could not be loaded, because it was created with a version of Microsoft Office prior to Office 2007."
],
	"\u0000The document could not be loaded, because it contains an unsupported feature.\u0001": [
	"The document could not be loaded, because it contains an unsupported feature."
],
	"\u0000The document could not be loaded, because it contains grouped text frames.\u0001": [
	"The document could not be loaded, because it contains grouped text frames."
],
	"\u0000The document could not be loaded, because the document format is unknown\u0001": [
	"The document could not be loaded, because the document format is unknown"
],
	"\u0000The document could not be loaded into Presentation, because it's currently remotely presented. Please try again later.\u0001": [
	"The document could not be loaded into Presentation, because it is currently remotely presented. Please try again later."
],
	"\u0000The document could not be loaded. The file format is not supported.\u0001": [
	"The document could not be loaded. The file format is not supported."
],
	"\u0000The document could not be read, because you do not have read permissions.\u0001": [
	"The document could not be read because you do not have read permissions."
],
	"\u0000The document cannot be found. Please check, if the document has been removed.\u0001": [
	"The document cannot be found. Please check, if the document has been removed."
],
	"\u0000The document could not be loaded. The document is corrupt.\u0001": [
	"The document could not be loaded. The document is corrupt."
],
	"\u0000The document could not be loaded. An unknown error occurred. Please try again later.\u0001": [
	"The document could not be loaded. An unknown error occurred. Please try again later."
],
	"\u0000The system is currently busy to store the document. Please try again later.\u0001": [
	"The system is currently too busy to store the document. Please try again later."
],
	"\u0000You do not have sufficient permissions to write the backup file.\u0001": [
	"You do not have sufficient permissions to write the backup file."
],
	"\u0000An unknown error occurred.\u0001": [
	"An unknown error occurred."
],
	"\u0000There is a configuration problem on the server. Please contact the server administrator.\u0001": [
	"There is a configuration problem on the server. Please contact the server administrator."
],
	"\u0000Your changes could not be written to the original document. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Your changes could not be written to the original document. To save your work, please copy the complete content into the clipboard and paste it into a new document."
],
	"\u0000The connection to the document has been lost. Please reload the document.\u0001": [
	"The connection to the document has been lost. Please reload the document."
],
	"\u0000The image type is not supported. The image cannot be embedded into the document.\u0001": [
	"The image type is not supported. The image cannot be embedded into the document."
],
	"\u0000A server component is not working correctly. Please contact the server administrator.\u0001": [
	"A server component is not working correctly. Please contact the server administrator."
],
	"\u0000The document could not be opened. The maximum number of simultaneously opened documents has been reached. Please close another document first and then open this document again.\u0001": [
	"The document could not be opened. The maximum number of simultaneously opened documents has been reached. Please close another document first and then open this document again."
],
	"\u0000The document could not be loaded. Decrypting the document failed.\u0001": [
	"The document could not be loaded. Decrypting the document failed."
],
	"\u0000The document could not be loaded. There is no document content available as the file size is zero.\u0001": [
	"The document could not be loaded. There is no document content available as the file size is zero."
],
	"\u0000The document could not be loaded. The authentication for the Guard component failed. Please check your password.\u0001": [
	"The document could not be loaded. The authentication for the Guard component failed. Please check your password."
],
	"\u0000Error\u0001": [
	"Error"
],
	"\u0000The document exceeds the maximum permitted size of %1$s MB.\u0001": [
	"The document exceeds the maximum permitted size of %1$s MB."
],
	"\u0000The image cannot be embedded into the document because it exceeds the maximum permitted size of %1$s MB. The URL is used instead.\u0001": [
	"The image cannot be embedded into the document because it exceeds the maximum permitted size of %1$s MB. The URL is used instead."
],
	"\u0000The image cannot be embedded into the document because it exceeds the maximum permitted size. The URL is used instead.\u0001": [
	"The image cannot be embedded into the document because it exceeds the maximum permitted size. The URL is used instead."
],
	"\u0000The document has been locked by %1$s.\u0001": [
	"The document has been locked by %1$s."
],
	"\u0000The document has been locked by another user.\u0001": [
	"The document has been locked by another user."
],
	"\u0000Your changes could not be written to the original document. A new document \"%1$s\" was stored in folder \"%2$s\" containing your latest changes.\u0001": [
	"Your changes could not be written to the original document. A new document \"%1$s\" was stored in folder \"%2$s\" containing your latest changes."
],
	"\u0000Your changes could not be written to the original document. A new document was stored containing your latest changes.\u0001": [
	"Your changes could not be written to the original document. A new document was stored containing your latest changes."
],
	"\u0000Your changes could not be written to the original document. A new document \"%1$s\" was stored in folder \"%2$s\" but some of your latest changes could not be saved. To save all of your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Your changes could not be written to the original document. A new document \"%1$s\" was stored in folder \"%2$s\" but some of your latest changes could not be saved. To save all of your latest changes, please copy the complete contents into the clipboard and paste it into a new document."
],
	"\u0000Your changes could not be written to the original document. A new document was stored but some of your latest changes could not be saved. To save all of your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Your changes could not be written to the original document. A new document was stored but some of your latest changes could not be saved. To save all of your latest changes, please copy the complete contents into the clipboard and paste it into a new document."
],
	"\u0000The document cannot be loaded, because an older version of the document is currently in use by \"%1$s\". Please contact \"%1$s\" or try again later.\u0001": [
	"The document cannot be loaded, because an older version of the document is currently in use by \"%1$s\". Please contact \"%1$s\" or try again later."
],
	"\u0000The document cannot be loaded, because an older version of the document is currently in use by someone. Please try again later.\u0001": [
	"The document cannot be loaded, because an older version of the document is currently in use by someone else. Please try again later."
],
	"\u0000The permissions of the document have changed. The document could not be saved, because \"%1$s\" lost write permission. Please contact \"%1$s\" to continue the collaboration or close the document and try to open it later.\u0001": [
	"The permissions of the document have changed. The document could not be saved, because \"%1$s\" lost write permission. Please contact \"%1$s\" to continue the collaboration or close the document and try to open it later."
],
	"\u0000The permissions of the document have changed. The document could not be saved, because the editor lost write permission. Please contact the editor to continue the collaboration or close the document and try to open it later.\u0001": [
	"The permissions of the document have changed. The document could not be saved, because the editor lost write permission. Please contact the editor to continue the collaboration or close the document and try to open it later."
],
	"\u0000The permissions of the document have changed. The document could not be saved, because \"%1$s\" lost read permission. Please contact \"%1$s\" to continue the collaboration or close the document and try to open it later.\u0001": [
	"The permissions of the document have changed. The document could not be saved, because \"%1$s\" lost read permission. Please contact \"%1$s\" to continue the collaboration or close the document and try to open it later."
],
	"\u0000The permissions of the document have changed. The document could not be saved, because the editor lost read permission. Please contact the editor to continue the collaboration or close the document and try to open it later.\u0001": [
	"The permissions of the document have changed. The document could not be saved, because the editor lost read permission. Please contact the editor to continue the collaboration or close the document and try to open it later."
],
	"\u0000The document is in an inconsistent state. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"The document is in an inconsistent state. To save your work, please copy the complete contents into the clipboard and paste them into a new document."
],
	"\u0000Could not create document, because of an unknown error.\u0001": [
	"Could not create document, because of an unknown error."
],
	"\u0000The new document could not be saved, because of an unknown error.\u0001": [
	"The new document could not be saved, because of an unknown error."
],
	"\u0000An unknown synchronization error occurred.\u0001": [
	"An unknown synchronisation error occurred."
],
	"\u0000An unknown error ocurred.\u0001": [
	"An unknown error ocurred."
],
	"\u0000Synchronization Error\u0001": [
	"Synchronisation Error"
],
	"\u0000Synchronization\u0001": [
	"Synchronisation"
],
	"\u0000Connection Error\u0001": [
	"Connection Error"
],
	"\u0000Connection Warning\u0001": [
	"Connection Warning"
],
	"\u0000Warning\u0001": [
	"Warning"
],
	"\u0000Rename Error\u0001": [
	"Rename Error"
],
	"\u0000Rename Warning\u0001": [
	"Rename Warning"
],
	"\u0000Read-Only Mode\u0001": [
	"Read-Only Mode"
],
	"\u0000Restore Document Error\u0001": [
	"Restore Document Error"
],
	"\u0000Synchronization between client and server was successful. You can edit the document again.\u0001": [
	"Synchronisation between client and server was successful. You can edit the document again."
],
	"\u0000Synchronization between client and server was successful. You see the latest document content.\u0001": [
	"Synchronisation between client and server was successful. You can see the latest document content."
],
	"\u0000Edit rights are being transferred to you. Please wait a moment.\u0001": [
	"Edit rights are being transferred to you. Please wait a moment."
],
	"\u0000Edit rights cannot be transferred. The server is busy to save the document. Please try again later.\u0001": [
	"Edit rights cannot be transferred. The server is too busy to save the document. Please try again later."
],
	"\u0000Edit rights are still being transferred to you. The system is busy and will need more time. Please be patient.\u0001": [
	"Edit rights are still being transferred to you. The system is busy and will need more time. Please be patient."
],
	"\u0000Someone else already wants to receive the edit rights for this document. Please try again later.\u0001": [
	"Someone else has already requested edit rights for this document. Please try again later."
],
	"\u0000You have edit rights.\u0001": [
	"You have edit rights."
],
	"\u0000Please wait until document is loaded completely.\u0001": [
	"Please wait until the document is loaded completely."
],
	"\u0000Saving your document failed, we can try to restore your document using backup data.\u0001": [
	"Saving your document failed, we can try to restore your document using backup data."
],
	"\u0000The synchronization process between client and server was not successful.\u0001": [
	"The synchronisation process between client and server was not successful."
],
	"\u0000Image\u0001": [
	"Image"
],
	"\u0000The image could not be embedded into the document. The external URL is used instead.\u0001": [
	"The image could not be embedded into the document. The external URL is used instead."
],
	"\u0000Transferring edit rights to %1$s. Your latest changes will be saved now.\u0001": [
	"Transferring edit rights to %1$s. Your latest changes will be saved now."
],
	"\u0000Transferring edit rights to another user. Your latest changes will be saved now.\u0001": [
	"Transferring edit rights to another user. Your latest changes will be saved now."
],
	"\u0000%1$s is currently editing this document.\u0001": [
	"%1$s is currently editing this document."
],
	"\u0000Another user is currently editing this document.\u0001": [
	"Another user is currently editing this document."
],
	"\u0000Document was converted and stored in your documents folder as \"%1$s\".\u0001": [
	"Document was converted and stored in your documents folder as \"%1$s\"."
],
	"\u0000Document was converted and stored as \"%1$s\".\u0001": [
	"Document was converted and stored as \"%1$s\"."
],
	"\u0000Document \"%1$s\" was created in your documents folder to allow editing.\u0001": [
	"Document \"%1$s\" was created in your documents folder to allow editing."
],
	"\u0000Document has been stored in your documents folder as \"%1$s\".\u0001": [
	"Document has been stored in your documents folder as \"%1$s\"."
],
	"\u0000The document was saved as a template \"%1$s\" in folder \"%2$s\".\u0001": [
	"The document was saved as a template \"%1$s\" in folder \"%2$s\"."
],
	"\u0000Document \"%1$s\" was created in folder \"%2$s\".\u0001": [
	"Document \"%1$s\" was created in folder \"%2$s\"."
],
	"\u0000Your document could be restored as \"%1$s\" successfully.\u0001": [
	"Your document could be restored as \"%1$s\" successfully."
],
	"\u0000Restore Document\u0001": [
	"Restore Document"
],
	"\u0000unnamed\u0001": [
	"unnamed"
],
	"document-name\u0000Text document\u0001": [
	"Text document"
],
	"document-name\u0000Text document (encrypted)\u0001": [
	"Text document (encrypted)"
],
	"document-name\u0000New text document\u0001": [
	"New text document"
],
	"document-name\u0000New text document (encrypted)\u0001": [
	"New text document (encrypted)"
],
	"document-name\u0000Spreadsheet\u0001": [
	"Spreadsheet"
],
	"document-name\u0000Spreadsheet (encrypted)\u0001": [
	"Spreadsheet (encrypted)"
],
	"document-name\u0000New spreadsheet\u0001": [
	"New spreadsheet"
],
	"document-name\u0000New spreadsheet (encrypted)\u0001": [
	"New spreadsheet (encrypted)"
],
	"document-name\u0000Presentation\u0001": [
	"Presentation"
],
	"document-name\u0000Presentation (encrypted)\u0001": [
	"Presentation (encrypted)"
],
	"document-name\u0000New presentation\u0001": [
	"New presentation"
],
	"document-name\u0000New presentation (encrypted)\u0001": [
	"New presentation (encrypted)"
],
	"menu-title\u0000View\u0001": [
	"View"
],
	"menu-title\u0000More\u0001": [
	"More"
],
	"menu-title\u0000Options\u0001": [
	"Options"
],
	"menu-title\u0000Zoom\u0001": [
	"Zoom"
],
	"\u0000Download\u0001": [
	"Download"
],
	"\u0000Print as PDF\u0001": [
	"Print as PDF"
],
	"\u0000Send as mail\u0001": [
	"Send as e-mail"
],
	"\u0000Attach document to mail\u0001": [
	"Attach document to e-mail"
],
	"\u0000Attach as PDF to mail\u0001": [
	"Attach as PDF to e-mail"
],
	"\u0000Send content as mail\u0001": [
	"Send content as e-mail"
],
	"\u0000Edit document\u0001": [
	"Edit document"
],
	"\u0000Edit\u0001": [
	"Edit"
],
	"\u0000Reload document\u0001": [
	"Reload document"
],
	"\u0000Reload\u0001": [
	"Reload"
],
	"\u0000Load restored document\u0001": [
	"Load restored document"
],
	"\u0000Load\u0001": [
	"Load"
],
	"\u0000Fit to screen width\u0001": [
	"Fit to screen width"
],
	"\u0000Fit to screen size\u0001": [
	"Fit to screen size"
],
	"\u0000Open document\u0001": [
	"Open document"
],
	"\u0000Add template\u0001": [
	"Add template"
],
	"\u0000Close document\u0001": [
	"Close document"
],
	"\u0000Zoom out\u0001": [
	"Zoom out"
],
	"\u0000Zoom in\u0001": [
	"Zoom in"
],
	"\u0000%1$d%\u0001": [
	"%1$d%"
],
	"\u0000Image could not be loaded.\u0001": [
	"Image could not be loaded."
],
	"chart-format\u0000Grayscale\u0001": [
	"Greyscale"
],
	"chart-format\u0000Accents\u0001": [
	"Accents"
],
	"chart-format\u0000Color set\u0001": [
	"Colour set"
],
	"chart-format\u0000Predefined color set\u0001": [
	"Predefined colour set"
],
	"chart-format\u0000Color\u0001": [
	"Colour"
],
	"chart-legend\u0000Legend position\u0001": [
	"Legend position"
],
	"chart-legend\u0000Visibility and position of the chart legend\u0001": [
	"Visibility and position of the chart legend"
],
	"chart-legend\u0000Legend\u0001": [
	"Legend"
],
	"chart-legend\u0000Off\u0001": [
	"Off"
],
	"chart-legend\u0000Top\u0001": [
	"Top"
],
	"chart-legend\u0000Bottom\u0001": [
	"Bottom"
],
	"chart-legend\u0000Left\u0001": [
	"Left"
],
	"chart-legend\u0000Right\u0001": [
	"Right"
],
	"chart-format\u0000Style set\u0001": [
	"Style set"
],
	"chart-format\u0000Predefined style set\u0001": [
	"Predefined style set"
],
	"chart-format\u0000Style\u0001": [
	"Style"
],
	"chart-format\u0000Light\u0001": [
	"Light"
],
	"chart-format\u0000Colored\u0001": [
	"Coloured"
],
	"chart-format\u0000Dark\u0001": [
	"Dark"
],
	"\u0000Chart type\u0001": [
	"Chart type"
],
	"drawing-pos\u0000Align\u0001": [
	"Align"
],
	"drawing-pos\u0000Align left\u0001": [
	"Align left"
],
	"drawing-pos\u0000Align center\u0001": [
	"Align center"
],
	"drawing-pos\u0000Align right\u0001": [
	"Align right"
],
	"drawing-pos\u0000Align top\u0001": [
	"Align top"
],
	"drawing-pos\u0000Align middle\u0001": [
	"Align middle"
],
	"drawing-pos\u0000Align bottom\u0001": [
	"Align bottom"
],
	"drawing-pos\u0000Distribute horizontally on slide\u0001": [
	"Distribute horizontally on slide"
],
	"\u0000Distribute selected objects horizontally on slide\u0001": [
	"Distribute selected objects horizontally on slide"
],
	"drawing-pos\u0000Distribute vertically on slide\u0001": [
	"Distribute vertically on slide"
],
	"\u0000Distribute selected objects vertically on slide\u0001": [
	"Distribute selected objects vertically on slide"
],
	"drawing-pos\u0000Distribute horizontally among objects\u0001": [
	"Distribute horizontally among objects"
],
	"\u0000Distribute selected objects horizontally among themselves\u0001": [
	"Distribute selected objects horizontally among themselves"
],
	"drawing-pos\u0000Distribute vertically among objects\u0001": [
	"Distribute vertically among objects"
],
	"\u0000Distribute selected objects vertically among themselves\u0001": [
	"Distribute selected objects vertically among themselves"
],
	"drawing-pos\u0000Arrange\u0001": [
	"Arrange"
],
	"drawing-pos\u0000Reorder\u0001": [
	"Reorder"
],
	"drawing-pos\u0000Rotate\u0001": [
	"Rotate"
],
	"drawing-pos\u0000Bring to front\u0001": [
	"Bring to front"
],
	"drawing-pos\u0000Bring object to the front\u0001": [
	"Bring object to the front"
],
	"drawing-pos\u0000Bring forward\u0001": [
	"Bring forward"
],
	"drawing-pos\u0000Move object up one placement to the front\u0001": [
	"Move object up one place"
],
	"drawing-pos\u0000Send backward\u0001": [
	"Send backward"
],
	"drawing-pos\u0000Send object one placement to the back\u0001": [
	"Send object one place back"
],
	"drawing-pos\u0000Send to back\u0001": [
	"Send to back"
],
	"drawing-pos\u0000Send object to the back\u0001": [
	"Send object to the back"
],
	"drawing-pos\u0000Rotate right 90°\u0001": [
	"Rotate right 90°"
],
	"drawing-pos\u0000Rotate right 90 degrees\u0001": [
	"Rotate right 90 degrees"
],
	"drawing-pos\u0000Rotate left 90°\u0001": [
	"Rotate left 90°"
],
	"drawing-pos\u0000Rotate left 90 degrees\u0001": [
	"Rotate left 90 degrees"
],
	"drawing-pos\u0000Flip vertical\u0001": [
	"Flip vertical"
],
	"drawing-pos\u0000Flip object vertical\u0001": [
	"Flip object vertical"
],
	"drawing-pos\u0000Flip horizontal\u0001": [
	"Flip horizontal"
],
	"drawing-pos\u0000Flip object horizontal\u0001": [
	"Flip object horizontal"
],
	"arrows\u0000Arrow style\u0001": [
	"Arrow style"
],
	"arrows\u0000Change line endings\u0001": [
	"Change line endings"
],
	"borders\u0000No line\u0001": [
	"No line"
],
	"borders\u0000Hair line\u0001": [
	"Hair line"
],
	"borders\u0000Thin line\u0001": [
	"Thin line"
],
	"borders\u0000Dashed thin line\u0001": [
	"Dashed thin line"
],
	"borders\u0000Dotted thin line\u0001": [
	"Dotted thin line"
],
	"borders\u0000Dot-and-dash thin line\u0001": [
	"Dot-and-dash thin line"
],
	"borders\u0000Two-dots-and-dash thin line\u0001": [
	"Two-dots-and-dash thin line"
],
	"borders\u0000Medium line\u0001": [
	"Medium line"
],
	"borders\u0000Dashed medium line\u0001": [
	"Dashed medium line"
],
	"borders\u0000Dotted medium line\u0001": [
	"Dotted medium line"
],
	"borders\u0000Dot-and-dash medium line\u0001": [
	"Dot-and-dash medium line"
],
	"borders\u0000Two-dots-and-dash medium line\u0001": [
	"Two-dots-and-dash medium line"
],
	"borders\u0000Thick line\u0001": [
	"Thick line"
],
	"drawing\u0000Line style\u0001": [
	"Line style"
],
	"drawing\u0000Border style\u0001": [
	"Border style"
],
	"\u0000Insert a shape\u0001": [
	"Insert a shape"
],
	"\u0000Shape\u0001": [
	"Shape"
],
	"\u0000Insert image\u0001": [
	"Insert image"
],
	"\u0000Upload local image\u0001": [
	"Upload local image"
],
	"\u0000Insert image URL\u0001": [
	"Insert image URL"
],
	"\u0000Enter image URL\u0001": [
	"Enter image URL"
],
	"drawing\u0000Line color\u0001": [
	"Line colour"
],
	"drawing\u0000Border color\u0001": [
	"Border color"
],
	"drawing\u0000Background color\u0001": [
	"Background colour"
],
	"drawing\u0000Insert a text frame\u0001": [
	"Insert a text frame"
],
	"\u0000Local file\u0001": [
	"Local file"
],
	"\u0000From Drive\u0001": [
	"From Drive"
],
	"\u0000From URL\u0001": [
	"From URL"
],
	"\u0000Crop\u0001": [
	"Crop"
],
	"\u0000Crop image\u0001": [
	"Crop image"
],
	"\u0000Fill\u0001": [
	"Fill"
],
	"\u0000Scale the image to fill the frame. The image aspect ratio is maintained. The image might be cropped\u0001": [
	"Scale the image to fill the frame. The image aspect ratio is maintained. The image might be cropped"
],
	"\u0000Fit\u0001": [
	"Fit"
],
	"\u0000Scale the image to fit the frame. The image aspect ratio is maintained. There might be empty space inside the frame.\u0001": [
	"Scale the image to fit the frame. The image aspect ratio is maintained. There might be empty space inside the frame."
],
	"\u0000Position ...\u0001": [
	"Position ..."
],
	"\u0000Open the crop position dialog\u0001": [
	"Open the crop position dialogue"
],
	"drawing\u0000Chart\u0001": [
	"Chart"
],
	"drawing\u0000Image\u0001": [
	"Image"
],
	"drawing\u0000Shape\u0001": [
	"Shape"
],
	"drawing\u0000Line\u0001": [
	"Line"
],
	"drawing\u0000Text frame\u0001": [
	"Text frame"
],
	"drawing\u0000Diagram\u0001": [
	"Diagram"
],
	"drawing\u0000Drawing\u0001": [
	"Drawing"
],
	"shape\u0000Lines\u0001": [
	"Lines"
],
	"shape\u0000Line\u0001": [
	"Line"
],
	"shape\u0000Line arrow\u0001": [
	"Line arrow"
],
	"shape\u0000Line arrow: double\u0001": [
	"Line arrow: double"
],
	"shape\u0000Connector: elbow\u0001": [
	"Connector: elbow"
],
	"shape\u0000Connector: elbow arrow\u0001": [
	"Connector: elbow arrow"
],
	"shape\u0000Connector: elbow double-arrow\u0001": [
	"Connector: elbow double arrow"
],
	"shape\u0000Connector: curved\u0001": [
	"Connector: curved"
],
	"shape\u0000Connector: curved arrow\u0001": [
	"Connector: curved arrow"
],
	"shape\u0000Connector: curved double-arrow\u0001": [
	"Connector: curved double arrow"
],
	"shape\u0000Basic shapes\u0001": [
	"Basic shapes"
],
	"shape\u0000Ellipse\u0001": [
	"Ellipse"
],
	"shape\u0000Isosceles triangle\u0001": [
	"Isosceles triangle"
],
	"shape\u0000Right triangle\u0001": [
	"Right triangle"
],
	"shape\u0000Parallelogram\u0001": [
	"Parallelogram"
],
	"shape\u0000Trapezoid\u0001": [
	"Trapezoid"
],
	"shape\u0000Diamond\u0001": [
	"Diamond"
],
	"shape\u0000Pentagon\u0001": [
	"Pentagon"
],
	"shape\u0000Hexagon\u0001": [
	"Hexagon"
],
	"shape\u0000Heptagon\u0001": [
	"Heptagon"
],
	"shape\u0000Octagon\u0001": [
	"Octagon"
],
	"shape\u0000Decagon\u0001": [
	"Decagon"
],
	"shape\u0000Dodecagon\u0001": [
	"Dodecagon"
],
	"shape\u0000Circle pie\u0001": [
	"Circle pie"
],
	"shape\u0000Circle segment\u0001": [
	"Circle segment"
],
	"shape\u0000Teardrop\u0001": [
	"Teardrop"
],
	"shape\u0000Frame\u0001": [
	"Frame"
],
	"shape\u0000Half frame\u0001": [
	"Half frame"
],
	"shape\u0000Corner\u0001": [
	"Corner"
],
	"shape\u0000Diagonal stripe\u0001": [
	"Diagonal stripe"
],
	"shape\u0000Plus\u0001": [
	"Plus"
],
	"shape\u0000Plaque\u0001": [
	"Plaque"
],
	"shape\u0000Cylinder\u0001": [
	"Cylinder"
],
	"shape\u0000Cube\u0001": [
	"Cube"
],
	"shape\u0000Funnel\u0001": [
	"Funnel"
],
	"shape\u0000Rectangle bevel\u0001": [
	"Rectangle bevel"
],
	"shape\u0000Ring\u0001": [
	"Ring"
],
	"shape\u0000No symbol\u0001": [
	"No symbol"
],
	"shape\u0000Block arc\u0001": [
	"Block arc"
],
	"shape\u0000Folded corner\u0001": [
	"Folded corner"
],
	"shape\u0000Smiley face\u0001": [
	"Smiley face"
],
	"shape\u0000Heart\u0001": [
	"Heart"
],
	"shape\u0000Lightning bolt\u0001": [
	"Lightning bolt"
],
	"shape\u0000Sun\u0001": [
	"Sun"
],
	"shape\u0000Moon\u0001": [
	"Moon"
],
	"shape\u0000Cloud\u0001": [
	"Cloud"
],
	"shape\u0000Arc\u0001": [
	"Arc"
],
	"shape\u0000Double bracket\u0001": [
	"Double bracket"
],
	"shape\u0000Double brace\u0001": [
	"Double brace"
],
	"shape\u0000Left bracket\u0001": [
	"Left bracket"
],
	"shape\u0000Right bracket\u0001": [
	"Right bracket"
],
	"shape\u0000Left brace\u0001": [
	"Left brace"
],
	"shape\u0000Right brace\u0001": [
	"Right brace"
],
	"shape\u0000Square tabs\u0001": [
	"Square tabs"
],
	"shape\u0000Corner tabs\u0001": [
	"Corner tabs"
],
	"shape\u0000Plaque tabs\u0001": [
	"Plaque tabs"
],
	"shape\u0000Quarter pie\u0001": [
	"Quarter pie"
],
	"shape\u0000Plus sign\u0001": [
	"Plus sign"
],
	"shape\u0000Times sign\u0001": [
	"Times sign"
],
	"shape\u0000Rectangles\u0001": [
	"Rectangles"
],
	"shape\u0000Rectangle\u0001": [
	"Rectangle"
],
	"shape\u0000Rectangle: rounded corners\u0001": [
	"Rectangle: rounded corners"
],
	"shape\u0000Rectangle: single corner snipped\u0001": [
	"Rectangle: single corner snipped"
],
	"shape\u0000Rectangle: top corners snipped\u0001": [
	"Rectangle: top corners snipped"
],
	"shape\u0000Rectangle: diagonal corners snipped\u0001": [
	"Rectangle: diagonal corners snipped"
],
	"shape\u0000Rectangle: top corners one rounded one snipped\u0001": [
	"Rectangle: top corners one rounded one snipped"
],
	"shape\u0000Rectangle: single corner rounded\u0001": [
	"Rectangle: single corner rounded"
],
	"shape\u0000Rectangle: top corners rounded\u0001": [
	"Rectangle: top corners rounded"
],
	"shape\u0000Rectangle: diagonal corners rounded\u0001": [
	"Rectangle: diagonal corners rounded"
],
	"shape\u0000Block arrows\u0001": [
	"Block arrows"
],
	"shape\u0000Arrow: right\u0001": [
	"Arrow: right"
],
	"shape\u0000Arrow: left\u0001": [
	"Arrow: left"
],
	"shape\u0000Arrow: up\u0001": [
	"Arrow: up"
],
	"shape\u0000Arrow: down\u0001": [
	"Arrow: down"
],
	"shape\u0000Arrow: left-right\u0001": [
	"Arrow: left-right"
],
	"shape\u0000Arrow: up-down\u0001": [
	"Arrow: up-down"
],
	"shape\u0000Arrow: quad\u0001": [
	"Arrow: quad"
],
	"shape\u0000Arrow: left-right-up\u0001": [
	"Arrow: left-right-up"
],
	"shape\u0000Arrow: right-bent\u0001": [
	"Arrow: right-bent"
],
	"shape\u0000Arrow: u-turn\u0001": [
	"Arrow: u-turn"
],
	"shape\u0000Arrow: left-up\u0001": [
	"Arrow: left-up"
],
	"shape\u0000Arrow: up-bent\u0001": [
	"Arrow: up-bent"
],
	"shape\u0000Arrow: curved right\u0001": [
	"Arrow: curved right"
],
	"shape\u0000Arrow: curved left\u0001": [
	"Arrow: curved left"
],
	"shape\u0000Arrow: curved up\u0001": [
	"Arrow: curved up"
],
	"shape\u0000Arrow: curved down\u0001": [
	"Arrow: curved down"
],
	"shape\u0000Arrow: circular right\u0001": [
	"Arrow: circular right"
],
	"shape\u0000Arrow: circular left\u0001": [
	"Arrow: circular left"
],
	"shape\u0000Arrow: striped right\u0001": [
	"Arrow: striped right"
],
	"shape\u0000Arrow: notched right\u0001": [
	"Arrow: notched right"
],
	"shape\u0000Arrow: pentagon\u0001": [
	"Arrow: pentagon"
],
	"shape\u0000Arrow: chevron\u0001": [
	"Arrow: chevron"
],
	"shape\u0000Arrow: swoosh\u0001": [
	"Arrow: swoosh"
],
	"shape\u0000Flow charts\u0001": [
	"Flow charts"
],
	"shape\u0000Flowchart: process\u0001": [
	"Flowchart: process"
],
	"shape\u0000Flowchart: alternate process\u0001": [
	"Flowchart: alternate process"
],
	"shape\u0000Flowchart: decision\u0001": [
	"Flowchart: decision"
],
	"shape\u0000Flowchart: data\u0001": [
	"Flowchart: data"
],
	"shape\u0000Flowchart: predefined process\u0001": [
	"Flowchart: predefined process"
],
	"shape\u0000Flowchart: internal storage\u0001": [
	"Flowchart: internal storage"
],
	"shape\u0000Flowchart: document\u0001": [
	"Flowchart: document"
],
	"shape\u0000Flowchart: multidocument\u0001": [
	"Flowchart: multi-document"
],
	"shape\u0000Flowchart: terminator\u0001": [
	"Flowchart: terminator"
],
	"shape\u0000Flowchart: preparation\u0001": [
	"Flowchart: preparation"
],
	"shape\u0000Flowchart: manual input\u0001": [
	"Flowchart: manual input"
],
	"shape\u0000Flowchart: manual operation\u0001": [
	"Flowchart: manual operation"
],
	"shape\u0000Flowchart: connector\u0001": [
	"Flowchart: connector"
],
	"shape\u0000Flowchart: off-page connector\u0001": [
	"Flowchart: off-page connector"
],
	"shape\u0000Flowchart: Card\u0001": [
	"Flowchart: Card"
],
	"shape\u0000Flowchart: punched tape\u0001": [
	"Flowchart: punched tape"
],
	"shape\u0000Flowchart: summing junction\u0001": [
	"Flowchart: summing junction"
],
	"shape\u0000Flowchart: or\u0001": [
	"Flowchart: or"
],
	"shape\u0000Flowchart: collate\u0001": [
	"Flowchart: collate"
],
	"shape\u0000Flowchart: sort\u0001": [
	"Flowchart: sort"
],
	"shape\u0000Flowchart: extract\u0001": [
	"Flowchart: extract"
],
	"shape\u0000Flowchart: merge\u0001": [
	"Flowchart: merge"
],
	"shape\u0000Flowchart: stored data\u0001": [
	"Flowchart: stored data"
],
	"shape\u0000Flowchart: delay\u0001": [
	"Flowchart: delay"
],
	"shape\u0000Flowchart: magnetic tape\u0001": [
	"Flowchart: magnetic tape"
],
	"shape\u0000Flowchart: magnetic disk\u0001": [
	"Flowchart: magnetic disk"
],
	"shape\u0000Flowchart: magnetic drum\u0001": [
	"Flowchart: magnetic drum"
],
	"shape\u0000Flowchart: display\u0001": [
	"Flowchart: display"
],
	"shape\u0000Flowchart: offline storage\u0001": [
	"Flowchart: offline storage"
],
	"shape\u0000Stars and banners\u0001": [
	"Stars and banners"
],
	"shape\u0000Explosion: 12 points\u0001": [
	"Explosion: 12 points"
],
	"shape\u0000Explosion: 14 points\u0001": [
	"Explosion: 14 points"
],
	"shape\u0000Star: 4 points\u0001": [
	"Star: 4 points"
],
	"shape\u0000Star: 5 points\u0001": [
	"Star: 5 points"
],
	"shape\u0000Star: 6 points\u0001": [
	"Star: 6 points"
],
	"shape\u0000Star: 7 points\u0001": [
	"Star: 7 points"
],
	"shape\u0000Star: 8 points\u0001": [
	"Star: 8 points"
],
	"shape\u0000Star: 10 points\u0001": [
	"Star: 10 points"
],
	"shape\u0000Star: 12 points\u0001": [
	"Star: 12 points"
],
	"shape\u0000Star: 16 points\u0001": [
	"Star: 16 points"
],
	"shape\u0000Star: 24 points\u0001": [
	"Star: 24 points"
],
	"shape\u0000Star: 32 points\u0001": [
	"Star: 32 points"
],
	"shape\u0000Ribbon: tilted up\u0001": [
	"Ribbon: tilted up"
],
	"shape\u0000Ribbon: tilted down\u0001": [
	"Ribbon: tilted down"
],
	"shape\u0000Ribbon: curved and tilted up\u0001": [
	"Ribbon: curved and tilted up"
],
	"shape\u0000Ribbon: curved and tilted down\u0001": [
	"Ribbon: curved and tilted down"
],
	"shape\u0000Ribbon: left-right arrow\u0001": [
	"Ribbon: left-right arrow"
],
	"shape\u0000Scroll: vertical\u0001": [
	"Scroll: vertical"
],
	"shape\u0000Scroll: horizontal\u0001": [
	"Scroll: horizontal"
],
	"shape\u0000Wave\u0001": [
	"Wave"
],
	"shape\u0000Double wave\u0001": [
	"Double wave"
],
	"shape\u0000Equation\u0001": [
	"Equation"
],
	"shape\u0000Minus sign\u0001": [
	"Minus sign"
],
	"shape\u0000Multiplication sign\u0001": [
	"Multiplication sign"
],
	"shape\u0000Division sign\u0001": [
	"Division sign"
],
	"shape\u0000Equal\u0001": [
	"Equal"
],
	"shape\u0000Not equal\u0001": [
	"Not equal"
],
	"shape\u0000Callouts\u0001": [
	"Call-outs"
],
	"chart-type\u0000Column\u0001": [
	"Column"
],
	"chart-type\u0000Column (stacked)\u0001": [
	"Column (stacked)"
],
	"chart-type\u0000Column (percent)\u0001": [
	"Column (percent)"
],
	"chart-type\u0000Bar\u0001": [
	"Bar"
],
	"chart-type\u0000Bar (stacked)\u0001": [
	"Bar (stacked)"
],
	"chart-type\u0000Bar (percent)\u0001": [
	"Bar (percent)"
],
	"chart-type\u0000Line\u0001": [
	"Line"
],
	"chart-type\u0000Line (curved)\u0001": [
	"Line (curved)"
],
	"chart-type\u0000Line (marker)\u0001": [
	"Line (marker)"
],
	"chart-type\u0000Scatter\u0001": [
	"Scatter"
],
	"chart-type\u0000Scatter (curved)\u0001": [
	"Scatter (curved)"
],
	"chart-type\u0000Scatter (marker)\u0001": [
	"Scatter (marker)"
],
	"chart-type\u0000Bubble\u0001": [
	"Bubble"
],
	"chart-type\u0000Pie\u0001": [
	"Pie"
],
	"chart-type\u0000Donut\u0001": [
	"Donut"
],
	"chart-type\u0000Area\u0001": [
	"Area"
],
	"chart-type\u0000Area (stacked)\u0001": [
	"Area (stacked)"
],
	"chart-type\u0000Area (percent)\u0001": [
	"Area (percent)"
],
	"drawing\u0000Insert an image\u0001": [
	"Insert an image"
],
	"drawing\u0000Delete\u0001": [
	"Delete"
],
	"drawing\u0000Delete the drawing object\u0001": [
	"Delete the drawing object"
],
	"drawing\u0000In front of text\u0001": [
	"In front of text"
],
	"drawing\u0000Format\u0001": [
	"Format"
],
	"drawing\u0000Format the drawing object\u0001": [
	"Format the drawing object"
],
	"drawing\u0000Group\u0001": [
	"Group"
],
	"drawing\u0000Group the selected drawings\u0001": [
	"Group the selected drawings"
],
	"drawing\u0000Ungroup\u0001": [
	"Ungroup"
],
	"drawing\u0000Ungroup the selected drawings\u0001": [
	"Ungroup the selected drawings"
],
	"drawing\u0000Crop\u0001": [
	"Crop"
],
	"drawing\u0000Crop image\u0001": [
	"Crop image"
],
	"drawing\u0000Insert a chart\u0001": [
	"Insert a chart"
],
	"chart-format\u0000Data points\u0001": [
	"Data points"
],
	"chart-format\u0000Show data point labels\u0001": [
	"Show data point labels"
],
	"chart-format\u0000Vary colors by point\u0001": [
	"Vary colours by point"
],
	"chart-format\u0000Labels\u0001": [
	"Labels"
],
	"chart-format\u0000Settings for labels and axes\u0001": [
	"Settings for labels and axes"
],
	"menu-title\u0000X axis options\u0001": [
	"X axis options"
],
	"menu-title\u0000Y axis options\u0001": [
	"Y axis options"
],
	"menu-title\u0000Z axis options\u0001": [
	"Z axis options"
],
	"menu-title\u0000X axis title\u0001": [
	"X axis title"
],
	"menu-title\u0000Y axis title\u0001": [
	"Y axis title"
],
	"menu-title\u0000Z axis title\u0001": [
	"Z axis title"
],
	"chart-format\u0000Type text to add a title\u0001": [
	"Type text to add a title"
],
	"menu-title\u0000Labels & Axes\u0001": [
	"Labels & Axes"
],
	"menu-title\u0000Chart title\u0001": [
	"Chart title"
],
	"chart-format\u0000Axis line\u0001": [
	"Axis line"
],
	"chart-format\u0000Grid lines\u0001": [
	"Grid lines"
],
	"\u0000%1$s is being asked to grant you edit rights. This might take some time.\u0001": [
	"%1$s is being asked to grant you edit rights. This might take some time."
],
	"\u0000The server is being asked to grant you edit rights. This might take some time.\u0001": [
	"The server is being asked to grant you edit rights. This might take some time."
],
	"\u0000The request takes longer than expected, trying again.\u0001": [
	"The request is taking longer than expected, trying again."
],
	"\u0000%1$s is asking for edit rights. This request will be accepted automatically in %2$d seconds.\u0001": [
	"%1$s is asking for edit rights. This request will be accepted automatically in %2$d seconds."
],
	"\u0000Decline\u0001": [
	"Decline"
],
	"\u0000Accept\u0001": [
	"Accept"
],
	"\u0000Your request for edit rights has been declined.\u0001": [
	"Your request for edit rights has been declined."
],
	"\u0000Sorry, your document is very large. It will take some time to be loaded.\u0001": [
	"Sorry, your document is very large. It will take some time to be loaded."
],
	"\u0000Document in use\u0001": [
	"Document in use"
],
	"\u0000%1$s edits this document since %2$s on %3$s. To avoid data loss, please open the document on %3$s. Do you want to cancel opening it here?\u0001": [
	"%1$s edits this document since %2$s on %3$s. To avoid data loss, please open the document on %3$s. Do you want to cancel opening it here?"
],
	"\u0000Another user edits this document since %1$s on %2$s. To avoid data loss, please open the document on %3$s. Do you want to cancel opening it here?\u0001": [
	"Another user has been editing this document since %1$s on %2$s. To avoid data loss, please open the document on %3$s. Do you want to cancel opening it here?"
],
	"\u0000This document contains unsaved changes. Do you really want to close?\u0001": [
	"This document contains unsaved changes. Do you really want to close?"
],
	"\u0000The image could not be inserted.\u0001": [
	"The image could not be inserted."
],
	"\u0000You cannot insert this large image from an insecure page.\u0001": [
	"You cannot insert this large image from an insecure page."
],
	"\u0000Save as (encrypted)\u0001": [
	"Save as (encrypted)"
],
	"\u0000Save as\u0001": [
	"Save as"
],
	"\u0000Copy of %1$s\u0001": [
	"Copy of %1$s"
],
	"\u0000Save as template (%1$s)\u0001": [
	"Save as template (%1$s)"
],
	"\u0000Export as PDF\u0001": [
	"Export as PDF"
],
	"\u0000What is AutoSave?\u0001": [
	"What is AutoSave?"
],
	"\u0000In OX Documents all your changes are saved automatically through AutoSave. It is not necessary to save your work manually.\u0001": [
	"In OX Documents all your changes are saved automatically through AutoSave. It is not necessary to save your work manually."
],
	"\u0000This document cannot be edited at the moment because a new version is being uploaded. Please wait until the upload is complete.\u0001": [
	"This document cannot be edited at the moment because a new version is being uploaded. Please wait until the upload is complete."
],
	"\u0000New from template\u0001": [
	"New from template"
],
	"\u0000Edit template\u0001": [
	"Edit template"
],
	"\u0000Edit as new\u0001": [
	"Edit as new"
],
	"\u0000Edit as new (encrypted)\u0001": [
	"Edit as new (encrypted)"
],
	"\u0000Present\u0001": [
	"Present"
],
	"\u0000Unnamed Style\u0001": [
	"Unnamed Style"
],
	"\u0000@mention or reply...\u0001": [
	"@mention or reply..."
],
	"\u0000@mention or comment...\u0001": [
	"@mention or comment..."
],
	"\u0000You added people to this comment. Attention: Due to missing permissions no email will be sent!\u0001": [
	"You added people to this comment. Attention: Due to missing permissions no email will be sent!"
],
	"\u0000You added people to this comment who will receive an email notification.\u0001": [
	"You added people to this comment who will receive an email notification."
],
	"\u0000Please post your comment.\u0001": [
	"Please post your comment."
],
	"comment-actions\u0000Send\u0001": [
	"Send"
],
	"comment-actions\u0000Discard\u0001": [
	"Discard"
],
	"\u0000Proceed\u0001": [
	"Proceed"
],
	"\u0000Cancel\u0001": [
	"Cancel"
],
	"\u0000This comment contains content this app cannot display. Editing may result in changing or losing that content. Click cancel if you do not want to risk it.\u0001": [
	"This comment contains content this app cannot display. Editing may result in changing or losing that content. Click cancel if you do not want to risk it."
],
	"\u0000Delete\u0001": [
	"Delete"
],
	"\u0000Delete thread\u0001": [
	"Delete thread"
],
	"\u0000View %1$d more reply\u0001View %1$d more replies": [
	"View %1$d more reply",
	"View %1$d more replies"
],
	"\u0000Acquire edit rights\u0001": [
	"Acquire edit rights"
],
	"borders\u0000Left border\u0001": [
	"Left border"
],
	"borders\u0000Right border\u0001": [
	"Right border"
],
	"borders\u0000Top border\u0001": [
	"Top border"
],
	"borders\u0000Bottom border\u0001": [
	"Bottom border"
],
	"borders\u0000Inner vertical borders\u0001": [
	"Inner vertical borders"
],
	"borders\u0000Inner horizontal borders\u0001": [
	"Inner horizontal borders"
],
	"borders\u0000No borders\u0001": [
	"No borders"
],
	"borders\u0000All borders\u0001": [
	"All borders"
],
	"borders\u0000Outer borders\u0001": [
	"Outer borders"
],
	"borders\u0000Inner borders\u0001": [
	"Inner borders"
],
	"borders\u0000Left and right borders\u0001": [
	"Left and right borders"
],
	"borders\u0000Top and bottom borders\u0001": [
	"Top and bottom borders"
],
	"borders\u0000All vertical borders\u0001": [
	"All vertical borders"
],
	"borders\u0000All horizontal borders\u0001": [
	"All horizontal borders"
],
	"borders\u0000Inner vertical and outer borders\u0001": [
	"Inner vertical and outer borders"
],
	"borders\u0000Inner horizontal and outer borders\u0001": [
	"Inner horizontal and outer borders"
],
	"borders\u0000Borders\u0001": [
	"Borders"
],
	"borders\u0000%1$d point\u0001%1$d points": [
	"%1$d point",
	"%1$d points"
],
	"\u0000Dark red\u0001": [
	"Dark red"
],
	"\u0000Red\u0001": [
	"Red"
],
	"\u0000Orange\u0001": [
	"Orange"
],
	"\u0000Yellow\u0001": [
	"Yellow"
],
	"\u0000Light green\u0001": [
	"Light green"
],
	"\u0000Green\u0001": [
	"Green"
],
	"\u0000Light blue\u0001": [
	"Light blue"
],
	"\u0000Blue\u0001": [
	"Blue"
],
	"\u0000Dark blue\u0001": [
	"Dark blue"
],
	"\u0000Purple\u0001": [
	"Purple"
],
	"\u0000%1$s, lighter %2$d%\u0001": [
	"%1$s, lighter %2$d%"
],
	"\u0000%1$s, darker %2$d%\u0001": [
	"%1$s, darker %2$d%"
],
	"\u0000No color\u0001": [
	"No colour"
],
	"\u0000Automatic color\u0001": [
	"Automatic colour"
],
	"\u0000Standard Colors\u0001": [
	"Standard Colours"
],
	"\u0000Theme Colors\u0001": [
	"Theme Colours"
],
	"\u0000Rename document\u0001": [
	"Rename document"
],
	"\u0000Document name\u0001": [
	"Document name"
],
	"\u0000Font name\u0001": [
	"Font name"
],
	"font\u0000(Headings)\u0001": [
	"(Headings)"
],
	"font\u0000(Body)\u0001": [
	"(Body)"
],
	"\u0000Font size\u0001": [
	"Font size"
],
	"\u0000Language\u0001": [
	"Language"
],
	"\u0000Text language\u0001": [
	"Text language"
],
	"language\u0000None\u0001": [
	"None"
],
	"\u0000New\u0001": [
	"New"
],
	"\u0000Recent documents and templates\u0001": [
	"Recent documents and templates"
],
	"\u0000Table size %1$s × %2$s\u0001": [
	"Table size %1$s × %2$s"
],
	"\u0000%1$d column\u0001%1$d columns": [
	"%1$d column",
	"%1$d columns"
],
	"\u0000%1$d row\u0001%1$d rows": [
	"%1$d row",
	"%1$d rows"
],
	"text-doc\u0000Table\u0001": [
	"Table"
],
	"text-doc\u0000Insert a table\u0001": [
	"Insert a table"
],
	"\u0000Table style\u0001": [
	"Table style"
],
	"\u0000Search\u0001": [
	"Search"
],
	"\u0000Replace\u0001": [
	"Replace"
],
	"\u0000Select a toolbar\u0001": [
	"Select a tool bar"
],
	"\u0000Guest\u0001": [
	"Guest"
],
	"\u0000This user has edit rights for the document.\u0001": [
	"This user has edit rights for the document."
],
	"\u0000You have edit rights for the document.\u0001": [
	"You have edit rights for the document."
],
	"\u0000Ctrl\u0001": [
	"Ctrl"
],
	"\u0000Cut, copy, and paste\u0001": [
	"Cut, copy, and paste"
],
	"\u0000Some actions are unavailable via the context menu. Please use these shortcuts:\u0001": [
	"Some actions are unavailable via the context menu. Please use these shortcuts:"
],
	"\u0000%1$s + X\u0001": [
	"%1$s + X"
],
	"\u0000%1$s + C\u0001": [
	"%1$s + C"
],
	"\u0000%1$s + V\u0001": [
	"%1$s + V"
],
	"\u0000You cannot use contacts in comments\u0001": [
	"You cannot use contacts in comments"
],
	"\u0000You used a contact in a comment to send this contact a notification. This feature is not supported for your account. No notifications will be sent.\u0001": [
	"You used a contact in a comment to send this contact a notification. This feature is not supported for your account. No notifications will be sent."
],
	"\u0000Comment anyway\u0001": [
	"Comment anyway"
],
	"\u0000Share file \"%1$s\"\u0001": [
	"Share file \"%1$s\""
],
	"\u0000These recipients do not have \"Reviewer\" permissions to this file. They will not be able to edit it unless you share the file with them. Every recipient gets an individual email.\u0001": [
	"These recipients do not have \"Reviewer\" permissions for this file. They will not be able to edit it unless you share the file with them. Every recipient gets an individual e-mail."
],
	"\u0000Share\u0001": [
	"Share"
],
	"\u0000Someone needs access to this file\u0001": [
	"Someone needs access to this file"
],
	"\u0000These recipients do not have permissions to this file. Please contact the owner of the file to grant them permissions.\u0001": [
	"These recipients do not have permissions for this file. Please contact the owner of the file to grant them permissions."
],
	"\u0000Internal user\u0001": [
	"Internal user"
],
	"\u0000Insert\u0001": [
	"Insert"
],
	"\u0000URL\u0001": [
	"URL"
],
	"\u0000Text\u0001": [
	"Text"
],
	"\u0000Remove\u0001": [
	"Remove"
],
	"\u0000Open\u0001": [
	"Open"
],
	"\u0000There is an unposted comment in this document.\u0001": [
	"There is an unposted comment in this document."
],
	"\u0000There is an unposted comment on this sheet.\u0001": [
	"There is an unposted comment on this sheet."
],
	"\u0000There is an unposted comment on this slide.\u0001": [
	"There is an unposted comment on this slide."
],
	"\u0000You have added a comment that you have not yet posted. What do you want to do?\u0001": [
	"You have added a comment that you have not yet posted. What do you want to do?"
],
	"\u0000You have edited a comment that you have not yet posted. What do you want to do?\u0001": [
	"You have edited a comment that you have not yet posted. What do you want to do?"
],
	"\u0000Continue and discard comment\u0001": [
	"Continue and discard comment"
],
	"\u0000Continue and discard edits\u0001": [
	"Continue and discard edits"
],
	"\u0000Back to comment\u0001": [
	"Back to comment"
],
	"\u0000Text color\u0001": [
	"Text colour"
],
	"\u0000Fill color\u0001": [
	"Fill colour"
],
	"\u0000Save in Drive\u0001": [
	"Save in Drive"
],
	"\u0000Save as template\u0001": [
	"Save as template"
],
	"\u0000AutoSave\u0001": [
	"AutoSave"
],
	"menu-title\u0000File\u0001": [
	"File"
],
	"menu-title\u0000Format\u0001": [
	"Format"
],
	"menu-title\u0000Insert\u0001": [
	"Insert"
],
	"menu-title\u0000Font\u0001": [
	"Font"
],
	"menu-title\u0000Alignment\u0001": [
	"Alignment"
],
	"menu-title\u0000Number format\u0001": [
	"Number format"
],
	"menu-title\u0000Slide\u0001": [
	"Slide"
],
	"menu-title\u0000Slide Show\u0001": [
	"Slide Show"
],
	"menu-title\u0000Table\u0001": [
	"Table"
],
	"menu-title\u0000Review\u0001": [
	"Review"
],
	"menu-title\u0000Comments\u0001": [
	"Comments"
],
	"menu-title\u0000Change tracking\u0001": [
	"Change tracking"
],
	"menu-title\u0000Paragraph styles\u0001": [
	"Paragraph styles"
],
	"menu-title\u0000Paragraph\u0001": [
	"Paragraph"
],
	"menu-title\u0000List settings\u0001": [
	"List settings"
],
	"menu-title\u0000Font styles\u0001": [
	"Font styles"
],
	"menu-title\u0000Cell border\u0001": [
	"Cell border"
],
	"borders\u0000Cell borders\u0001": [
	"Cell borders"
],
	"borders\u0000Border color\u0001": [
	"Border color"
],
	"borders\u0000Border style\u0001": [
	"Border style"
],
	"borders\u0000Border width\u0001": [
	"Border width"
],
	"\u0000Clear formatting\u0001": [
	"Clear formatting"
],
	"h-alignment\u0000Left\u0001": [
	"Left"
],
	"h-alignment\u0000Center\u0001": [
	"Centre"
],
	"h-alignment\u0000Right\u0001": [
	"Right"
],
	"h-alignment\u0000Justify\u0001": [
	"Justify"
],
	"h-alignment\u0000Automatic\u0001": [
	"Automatic"
],
	"v-alignment\u0000Top\u0001": [
	"Top"
],
	"v-alignment\u0000Middle\u0001": [
	"Middle"
],
	"v-alignment\u0000Bottom\u0001": [
	"Bottom"
],
	"v-alignment\u0000Justify\u0001": [
	"Justify"
],
	"\u0000Hyperlink\u0001": [
	"Hyperlink"
],
	"\u0000Edit hyperlink\u0001": [
	"Edit hyperlink"
],
	"\u0000Remove hyperlink\u0001": [
	"Remove hyperlink"
],
	"\u0000Open hyperlink\u0001": [
	"Open hyperlink"
],
	"\u0000Insert hyperlink\u0001": [
	"Insert hyperlink"
],
	"\u0000Insert or edit a hyperlink\u0001": [
	"Insert or edit a hyperlink"
],
	"\u0000This hyperlink is invalid.\u0001": [
	"This hyperlink is invalid."
],
	"\u0000Revert last operation\u0001": [
	"Revert last operation"
],
	"\u0000Restore last operation\u0001": [
	"Restore last operation"
],
	"\u0000Comment\u0001": [
	"Comment"
],
	"\u0000Insert comment\u0001": [
	"Insert comment"
],
	"\u0000Write about\u0001": [
	"Write about"
],
	"\u0000Create new content with AI\u0001": [
	"Create new content with AI"
],
	"\u0000Rephrase\u0001": [
	"Rephrase"
],
	"\u0000Rephrase content with AI\u0001": [
	"Rephrase content with AI"
],
	"\u0000Summarize\u0001": [
	"Summarise"
],
	"\u0000Summarize content with AI\u0001": [
	"Summarise content with AI"
],
	"\u0000Translate\u0001": [
	"Translate"
],
	"\u0000Translate content with AI\u0001": [
	"Translate content with AI"
],
	"comment-actions\u0000Reply\u0001": [
	"Reply"
],
	"comment-actions\u0000Reply to comment\u0001": [
	"Reply to comment"
],
	"\u0000Cut\u0001": [
	"Cut"
],
	"\u0000Cut to clipboard\u0001": [
	"Cut to clipboard"
],
	"\u0000Copy\u0001": [
	"Copy"
],
	"\u0000Copy to clipboard\u0001": [
	"Copy to clipboard"
],
	"\u0000Paste\u0001": [
	"Paste"
],
	"\u0000Paste from clipboard\u0001": [
	"Paste from clipboard"
],
	"\u0000Delete contents\u0001": [
	"Delete contents"
],
	"\u0000Deleting the selected elements cannot be undone. Do you want to continue?\u0001": [
	"Deleting the selected elements cannot be undone. Do you want to continue?"
],
	"\u0000Delete rows\u0001": [
	"Delete rows"
],
	"\u0000Deleting the selected rows cannot be undone. Do you want to continue?\u0001": [
	"Deleting the selected rows cannot be undone. Do you want to continue?"
],
	"\u0000Delete columns\u0001": [
	"Delete columns"
],
	"\u0000Deleting the selected columns cannot be undone. Do you want to continue?\u0001": [
	"Deleting the selected columns cannot be undone. Do you want to continue?"
],
	"\u0000Bold\u0001": [
	"Bold"
],
	"\u0000Italic\u0001": [
	"Italic"
],
	"\u0000Underline\u0001": [
	"Underline"
],
	"\u0000Strike through\u0001": [
	"Strike through"
],
	"\u0000Show toolbars\u0001": [
	"Show tool bars"
],
	"\u0000Show or hide the toolbars\u0001": [
	"Show or hide the tool bars"
],
	"\u0000Show comments\u0001": [
	"Show comments"
],
	"\u0000Show or hide the comments\u0001": [
	"Show or hide the comments"
],
	"\u0000Show sidebar\u0001": [
	"Show side bar"
],
	"\u0000Show or hide the sidebar\u0001": [
	"Show or hide the side bar"
],
	"\u0000Show collaborators\u0001": [
	"Show collaborators"
],
	"\u0000Show or hide list of collaborators\u0001": [
	"Show or hide list of collaborators"
],
	"\u0000Text %1$d\u0001": [
	"Text %1$d"
],
	"\u0000Background %1$d\u0001": [
	"Background %1$d"
],
	"\u0000Accent %1$d\u0001": [
	"Accent %1$d"
],
	"\u0000Replace all\u0001": [
	"Replace all"
],
	"\u0000All\u0001": [
	"All"
],
	"\u0000Search ...\u0001": [
	"Search ..."
],
	"\u0000Find text\u0001": [
	"Find text"
],
	"\u0000%1$d result found\u0001%1$d results found": [
	"%1$d result found",
	"%1$d results found"
],
	"\u0000More than 99 results found\u0001": [
	"More than 99 results found"
],
	"\u0000Replace with ...\u0001": [
	"Replace with ..."
],
	"\u0000Replacement text\u0001": [
	"Replacement text"
],
	"\u0000Start search\u0001": [
	"Start search"
],
	"\u0000Select previous search result\u0001": [
	"Select previous search result"
],
	"\u0000Select next search result\u0001": [
	"Select next search result"
],
	"\u0000Replace selected search result and select the next result\u0001": [
	"Replace selected search result and select the next result"
],
	"\u0000Replace all search results\u0001": [
	"Replace all search results"
],
	"\u0000Your document contains unposted comments.\u0001": [
	"Your document contains unposted comments."
],
	"\u0000Loading document\u0001": [
	"Loading document"
],
	"\u0000Saving changes\u0001": [
	"Saving changes"
],
	"\u0000All changes saved\u0001": [
	"All changes saved"
],
	"\u0000Slide settings\u0001": [
	"Slide settings"
],
	"\u0000Page settings\u0001": [
	"Page settings"
],
	"\u0000Actions\u0001": [
	"Actions"
],
	"\u0000Share / Permissions\u0001": [
	"Share / Permissions"
],
	"\u0000Document is encrypted\u0001": [
	"Document is encrypted"
],
	"\u0000Toggle search\u0001": [
	"Toggle search"
],
	"\u0000Collaborators\u0001": [
	"Collaborators"
],
	"\u0000List of collaborators of this document\u0001": [
	"List of collaborators of this document"
],
	"comment-actions\u0000Hide comments pane\u0001": [
	"Hide comments pane"
],
	"\u0000Search recent documents\u0001": [
	"Search recent documents"
],
	"\u0000Show in Drive\u0001": [
	"Show in Drive"
],
	"\u0000Remove from list\u0001": [
	"Remove from list"
],
	"\u0000Clear list\u0001": [
	"Clear list"
],
	"\u0000New from template (encrypted)\u0001": [
	"New from template (encrypted)"
],
	"\u0000Delete template\u0001": [
	"Delete template"
],
	"\u0000System template\u0001": [
	"System template"
],
	"\u0000Global template\u0001": [
	"Global template"
],
	"\u0000User template\u0001": [
	"User template"
],
	"\u0000Blank text document\u0001": [
	"Blank text document"
],
	"\u0000New text document\u0001": [
	"New text document"
],
	"\u0000New text document (encrypted)\u0001": [
	"New text document (encrypted)"
],
	"\u0000Blank spreadsheet\u0001": [
	"Blank spreadsheet"
],
	"\u0000New spreadsheet\u0001": [
	"New spreadsheet"
],
	"\u0000New spreadsheet (encrypted)\u0001": [
	"New spreadsheet (encrypted)"
],
	"\u0000Blank presentation\u0001": [
	"Blank presentation"
],
	"\u0000New presentation\u0001": [
	"New presentation"
],
	"\u0000New presentation (encrypted)\u0001": [
	"New presentation (encrypted)"
],
	"\u0000Recent Documents\u0001": [
	"Recent Documents"
],
	"\u0000New from Template\u0001": [
	"New from Template"
],
	"\u0000Drop template files here for upload\u0001": [
	"Drop template files here for upload"
],
	"tour\u0000Toolbar\u0001": [
	"Tool bar"
],
	"tour\u0000At the top of the screen you will find the toolbar which shows all the common functions.\u0001": [
	"At the top of the screen you will find the tool bar which shows all the common functions."
],
	"tour\u0000Autosaving changes\u0001": [
	"Autosaving changes"
],
	"tour\u0000Changes are saved automatically whenever you work on your document.\u0001": [
	"Changes are saved automatically whenever you work on your document."
],
	"tour\u0000File tab\u0001": [
	"File tab"
],
	"tour\u0000The file tab offers you various ways to share or save your document.\u0001": [
	"The file tab offers you various ways to share or save your document."
],
	"tour\u0000Saving options\u0001": [
	"Saving options"
],
	"tour\u0000If you would like to store your document in a specific folder, just click on \"Save as\".\u0001": [
	"If you would like to store your document in a specific folder, just click on \"Save as\"."
],
	"tour\u0000You can also click on \"Save as template\" to create your own templates.\u0001": [
	"You can also click on \"Save as template\" to create your own templates."
],
	"tour\u0000Sending your document\u0001": [
	"Sending your document"
],
	"tour\u0000Sending your document by email is easy. Just click on the mail icon and you are ready to go!\u0001": [
	"Sending your document by e-mail is easy. Just click on the mail icon and you are ready to go!"
],
	"tour\u0000Closing document\u0001": [
	"Closing document"
],
	"tour\u0000The document can be closed now. As all changes are stored automatically, you do not need to save documents manually.\u0001": [
	"The document can be closed now. As all changes are stored automatically, you do not need to save documents manually."
],
	"tour\u0000Restart Guided Tour\u0001": [
	"Restart Guided Tour"
],
	"tour\u0000Hint: you can start guided tours, any time you need them, from the system menu.\u0001": [
	"Hint: you can start guided tours from the system menu any time you need them."
],
	"\u0000unknown\u0001": [
	"unknown"
],
	"\u0000The file cannot be uploaded as this is not a supported template.\u0001": [
	"The file cannot be uploaded as this is not a supported template."
],
	"\u0000Some files could not be uploaded as they are not supported templates.\u0001": [
	"Some files could not be uploaded as they are not supported templates."
],
	"tour\u0000The Presentation app\u0001": [
	"The Presentation app"
],
	"tour\u0000Welcome to your new Presentation app. This Guided Tour will introduce you to the most important functions of creating and editing presentations online.\u0001": [
	"Welcome to your new Presentation app. This Guided Tour will introduce you to the most important functions of creating and editing presentations online."
],
	"tour\u0000Templates\u0001": [
	"Templates"
],
	"tour\u0000Clicking on the Presentation app in the navigation bar displays an overview of all the templates available to you in Presentation.\u0001": [
	"Clicking on the Presentation app in the navigation bar displays an overview of all the templates available to you in Presentation."
],
	"tour\u0000Blank presentation\u0001": [
	"Blank presentation"
],
	"tour\u0000You can choose from a variety of templates to help you create professional presentations.\u0001": [
	"You can choose from a variety of templates to help you create professional presentations."
],
	"tour\u0000Let's start with a blank presentation.\u0001": [
	"Let's start with a blank presentation."
],
	"tour\u0000New slides\u0001": [
	"New slides"
],
	"tour\u0000With a click on \"Slide\" you can add new slides to your presentation. Choose \"Layout\" to change the design of the selected slide. Depending on your template, many different layouts and slide types are available to you.\u0001": [
	"With a click on \"Slide\" you can add new slides to your presentation. Choose \"Layout\" to change the design of the selected slide. Depending on your template, many different layouts and slide types are available to you."
],
	"tour\u0000Edit master\u0001": [
	"Edit master"
],
	"tour\u0000You can create and edit the layout of your slides by clicking on \"Edit master\". While editing your master slides, you are able to change back to edit your normal slides by clicking on \"Edit normal\".\u0001": [
	"You can create and edit the layout of your slides by clicking on \"Edit master\". While editing your master slides, you are able to change back to edit your normal slides by clicking on \"Edit normal\"."
],
	"tour\u0000Present slides\u0001": [
	"Present slides"
],
	"tour\u0000With a click on \"Present\" you can start a presentation of your slides right away.\u0001": [
	"With a click on \"Present\" you can start a presentation of your slides right away."
],
	"tour\u0000The Spreadsheet app\u0001": [
	"The Spreadsheet app"
],
	"tour\u0000Welcome to your new Spreadsheet app. This Guided Tour will introduce you to the most important functions of creating and editing spreadsheets online.\u0001": [
	"Welcome to your new Spreadsheet app. This Guided Tour will introduce you to the most important functions of creating and editing spreadsheets online."
],
	"tour\u0000Clicking on the Spreadsheet app in the navigation bar displays an overview of all the templates available to you in Spreadsheet.\u0001": [
	"Clicking on the Spreadsheet app in the navigation bar displays an overview of all the templates available to you in Spreadsheet."
],
	"tour\u0000Blank spreadsheet\u0001": [
	"Blank spreadsheet"
],
	"tour\u0000You can choose from a variety of templates to help you create professional documents.\u0001": [
	"You can choose from a variety of templates to help you create professional documents."
],
	"tour\u0000Let's start with a blank document.\u0001": [
	"Let's start with a blank document."
],
	"tour\u0000Formulas\u0001": [
	"Formulas"
],
	"tour\u0000You can use all the regular spreadsheet formulas by typing them into a cell.\u0001": [
	"You can use all the regular spreadsheet formulas by typing them into a cell."
],
	"tour\u0000Autocompletion\u0001": [
	"Autocompletion"
],
	"tour\u0000As soon as you start typing a formula, autocompletion offers you a list of matching functions to choose from.\u0001": [
	"As soon as you start typing a formula, autocompletion offers you a list of matching functions to choose from."
],
	"tour\u0000Displaying hidden formulas\u0001": [
	"Displaying hidden formulas"
],
	"tour\u0000If a result is displayed in a cell, the calculating formula will be displayed in the formula bar.\u0001": [
	"If a result is displayed in a cell, the formula will be displayed in the formula bar."
],
	"tour\u0000The Text app\u0001": [
	"The Text app"
],
	"tour\u0000Welcome to your new Text app. This Guided Tour will introduce you to the most important functions of creating and editing text documents online.\u0001": [
	"Welcome to your new Text app. This Guided Tour will introduce you to the most important functions of creating and editing text documents online."
],
	"tour\u0000Clicking on the Text app in the navigation bar displays an overview of all the templates available to you in Text.\u0001": [
	"Clicking on the Text app in the navigation bar displays an overview of all the templates available to you in Text."
],
	"tour\u0000Blank text document\u0001": [
	"Blank text document"
],
	"\u0000You have no recent documents.\u0001": [
	"You have no recent documents."
],
	"\u0000(no format)\u0001": [
	"(no format)"
],
	"\u0000Sorry, updating of all fields in document will take some time.\u0001": [
	"Sorry, updating of all fields in document will take some time."
],
	"\u0000Applying footer fields to all slides, please wait...\u0001": [
	"Applying footer fields to all slides, please wait..."
],
	"\u0000Applying footer fields to current layout and all following standard slides, please wait...\u0001": [
	"Applying footer fields to current layout and all following standard slides, please wait..."
],
	"\u0000Click to leave presentation ...\u0001": [
	"Click to leave presentation ..."
],
	"\u0000Delete comments\u0001": [
	"Delete comments"
],
	"\u0000All comments in this presentation will be removed. Do you want to continue?\u0001": [
	"All comments in this presentation will be removed. Do you want to continue?"
],
	"\u0000The search continues from the end of this presentation.\u0001": [
	"The search continues from the end of this presentation."
],
	"\u0000The search continues from the beginning of this presentation.\u0001": [
	"The search continues from the beginning of this presentation."
],
	"\u0000Searching for a thread did fail.\u0001": [
	"Searching for a thread failed."
],
	"\u0000Insert table\u0001": [
	"Insert table"
],
	"\u0000Insert media clip\u0001": [
	"Insert media clip"
],
	"\u0000Insert chart\u0001": [
	"Insert chart"
],
	"\u0000Insert online image\u0001": [
	"Insert online image"
],
	"\u0000Insert smart art graphic\u0001": [
	"Insert smart art graphic"
],
	"\u0000This document contains slide background images which can't be displayed: %s\u0001": [
	"This document contains slide background images which cannot be displayed: %s"
],
	"\u0000Audio and video are not supported yet.\u0001": [
	"Audio and video are not supported yet."
],
	"\u0000Applying changes, please wait...\u0001": [
	"Applying changes, please wait..."
],
	"\u0000Connector functionality is disabled because of too many drawings on current slide.\u0001": [
	"Connector functionality is disabled because of too many drawings on current slide."
],
	"\u0000Blank Slide\u0001": [
	"Blank Slide"
],
	"\u0000Title Slide\u0001": [
	"Title Slide"
],
	"\u0000Title, Content\u0001": [
	"Title, Content"
],
	"\u0000Title and 2 Contents\u0001": [
	"Title and 2 Contents"
],
	"\u0000Title Only\u0001": [
	"Title Only"
],
	"\u0000Centered Text\u0001": [
	"Centered Text"
],
	"\u0000Title, 2 Contents and Content\u0001": [
	"Title, 2 Contents and Content"
],
	"\u0000Title, Content and 2 Contents\u0001": [
	"Title, Content and 2 Contents"
],
	"\u0000Title, 2 Contents over Content\u0001": [
	"Title, 2 Contents over Content"
],
	"\u0000Title, Content over Content\u0001": [
	"Title, Content over Content"
],
	"\u0000Title, 4 Contents\u0001": [
	"Title, 4 Contents"
],
	"\u0000Title, 6 Contents\u0001": [
	"Title, 6 Contents"
],
	"\u0000Vertical Title, Vertical Text\u0001": [
	"Vertical Title, Vertical Text"
],
	"\u0000Title, Vertical Text\u0001": [
	"Title, Vertical Text"
],
	"\u0000Duplicating selected slides, please wait...\u0001": [
	"Duplicating selected slides, please wait..."
],
	"\u0000Applying background to all slides, please wait...\u0001": [
	"Applying background to all slides, please wait..."
],
	"\u0000Click to add text\u0001": [
	"Click to add text"
],
	"\u0000Click to add title\u0001": [
	"Click to add title"
],
	"\u0000Click to add subtitle\u0001": [
	"Click to add subtitle"
],
	"\u0000Media clip\u0001": [
	"Media clip"
],
	"\u0000Online image\u0001": [
	"Online image"
],
	"\u0000Chart\u0001": [
	"Chart"
],
	"\u0000Smart Art\u0001": [
	"Smart Art"
],
	"\u0000Click to add table\u0001": [
	"Click to add table"
],
	"\u0000Click to add image\u0001": [
	"Click to add image"
],
	"\u0000Slide Number\u0001": [
	"Slide Number"
],
	"\u0000Footer\u0001": [
	"Footer"
],
	"\u0000Date\u0001": [
	"Date"
],
	"\u0000Click icon to add image\u0001": [
	"Click icon to add image"
],
	"\u0000Click icon to add table\u0001": [
	"Click icon to add table"
],
	"\u0000Click icon to add chart\u0001": [
	"Click icon to add chart"
],
	"\u0000Click icon to add smart art graphic\u0001": [
	"Click icon to add smart art graphic"
],
	"\u0000Click icon to add clip art\u0001": [
	"Click icon to add clip art"
],
	"\u0000Click icon to add media\u0001": [
	"Click icon to add media"
],
	"\u0000Content placeholder\u0001": [
	"Content placeholder"
],
	"\u0000Vertical content placeholder\u0001": [
	"Vertical content placeholder"
],
	"\u0000Text placeholder\u0001": [
	"Text placeholder"
],
	"\u0000Vertical text placeholder\u0001": [
	"Vertical text placeholder"
],
	"\u0000Image placeholder\u0001": [
	"Image placeholder"
],
	"\u0000Table placeholder\u0001": [
	"Table placeholder"
],
	"\u0000Edit Master text styles\u0001": [
	"Edit Master text styles"
],
	"\u0000Second level\u0001": [
	"Second level"
],
	"\u0000Third level\u0001": [
	"Third level"
],
	"\u0000Fourth level\u0001": [
	"Fourth level"
],
	"\u0000Fifth level\u0001": [
	"Fifth level"
],
	"\u0000Click to edit Master title style\u0001": [
	"Click to edit Master title style"
],
	"\u0000There are no comments on this slide.\u0001": [
	"There are no comments on this slide."
],
	"\u0000Animations\u0001": [
	"Animations"
],
	"\u0000Select a slide animation for the slide changes\u0001": [
	"Select a slide animation for the slide changes"
],
	"\u0000No animation\u0001": [
	"No animation"
],
	"\u0000No slide animation\u0001": [
	"No slide animation"
],
	"\u0000Start with first slide\u0001": [
	"Start with first slide"
],
	"\u0000Start the presentation with the first slide\u0001": [
	"Start the presentation with the first slide"
],
	"\u0000Start with current slide\u0001": [
	"Start with current slide"
],
	"\u0000Start the presentation with the current slide\u0001": [
	"Start the presentation with the current slide"
],
	"\u0000Slide\u0001": [
	"Slide"
],
	"\u0000Insert new slide\u0001": [
	"Insert new slide"
],
	"\u0000Layout\u0001": [
	"Layout"
],
	"\u0000Change layout\u0001": [
	"Change layout"
],
	"\u0000Edit master\u0001": [
	"Edit master"
],
	"\u0000Edit normal\u0001": [
	"Edit normal"
],
	"\u0000Switch between editing master/layout slides and normal slides\u0001": [
	"Switch between editing master/layout slides and normal slides"
],
	"\u0000Placeholder\u0001": [
	"Placeholder"
],
	"\u0000Insert placeholder\u0001": [
	"Insert placeholder"
],
	"\u0000Date/Time object\u0001": [
	"Date/Time object"
],
	"\u0000Show or hide date and time placeholder object\u0001": [
	"Show or hide date and time placeholder object"
],
	"\u0000Footer object\u0001": [
	"Footer object"
],
	"\u0000Show or hide footer placeholder objects\u0001": [
	"Show or hide footer placeholder objects"
],
	"\u0000Slide number object\u0001": [
	"Slide number object"
],
	"\u0000Show or hide slide number object\u0001": [
	"Show or hide slide number object"
],
	"\u0000Title\u0001": [
	"Title"
],
	"\u0000Show or hide title placeholder object\u0001": [
	"Show or hide title placeholder object"
],
	"\u0000Text body\u0001": [
	"Text body"
],
	"\u0000Show or hide text body placeholder object\u0001": [
	"Show or hide text body placeholder object"
],
	"\u0000Footer objects\u0001": [
	"Footer objects"
],
	"\u0000Content\u0001": [
	"Content"
],
	"\u0000Content vertical\u0001": [
	"Content vertical"
],
	"\u0000Text vertical\u0001": [
	"Text vertical"
],
	"\u0000Table\u0001": [
	"Table"
],
	"\u0000Field\u0001": [
	"Field"
],
	"\u0000Insert field\u0001": [
	"Insert field"
],
	"\u0000Slide number\u0001": [
	"Slide number"
],
	"\u0000Date & time\u0001": [
	"Date & time"
],
	"\u0000Choose\u0001": [
	"Choose"
],
	"\u0000Line\u0001": [
	"Line"
],
	"\u0000Color\u0001": [
	"Colour"
],
	"\u0000Style\u0001": [
	"Style"
],
	"\u0000Arrow\u0001": [
	"Arrow"
],
	"\u0000No background\u0001": [
	"No background"
],
	"\u0000Transparency\u0001": [
	"Transparency"
],
	"\u0000Date and time\u0001": [
	"Date and time"
],
	"field-dialog\u0000Select format\u0001": [
	"Select format"
],
	"\u0000Update automatically\u0001": [
	"Update automatically"
],
	"\u0000Apply\u0001": [
	"Apply"
],
	"\u0000Fixed date\u0001": [
	"Fixed date"
],
	"\u0000Apply to all\u0001": [
	"Apply to all"
],
	"\u0000Background\u0001": [
	"Background"
],
	"\u0000Hide background graphics\u0001": [
	"Hide background graphics"
],
	"\u0000used by slide\u0001": [
	"used by slide"
],
	"\u0000used by slides\u0001": [
	"used by slides"
],
	"\u0000You are in the slide master view.\u0001": [
	"You are in the slide master view."
],
	"\u0000Leave slide master view\u0001": [
	"Leave slide master view"
],
	"\u0000Set slide background\u0001": [
	"Set slide background"
],
	"\u0000Format slide background\u0001": [
	"Format slide background"
],
	"\u0000Start the Presenter\u0001": [
	"Start the Presenter"
],
	"\u0000Delete this thread\u0001": [
	"Delete this thread"
],
	"\u0000Insert slide\u0001": [
	"Insert slide"
],
	"\u0000Insert layout slide\u0001": [
	"Insert layout slide"
],
	"\u0000Duplicate slide\u0001": [
	"Duplicate slide"
],
	"\u0000Delete slide\u0001": [
	"Delete slide"
],
	"\u0000Hide slide\u0001": [
	"Hide slide"
],
	"\u0000Unhide slide\u0001": [
	"Unhide slide"
],
	"\u0000Change master\u0001": [
	"Change master"
],
	"comment-actions\u0000Previous\u0001": [
	"Previous"
],
	"comment-actions\u0000Go to previous comment\u0001": [
	"Go to previous comment"
],
	"comment-actions\u0000Next\u0001": [
	"Next"
],
	"comment-actions\u0000Go to next comment\u0001": [
	"Go to next comment"
],
	"comment-actions\u0000Delete\u0001": [
	"Delete"
],
	"comment-actions\u0000Delete selected thread\u0001": [
	"Delete selected thread"
],
	"comment-actions\u0000Delete all\u0001": [
	"Delete all"
],
	"comment-actions\u0000Delete every comment\u0001": [
	"Delete every comment"
],
	"\u0000The table reached its maximum size. You cannot insert further rows.\u0001": [
	"The table has reached its maximum size. You cannot insert additional rows."
],
	"\u0000The table reached its maximum size. You cannot insert further columns.\u0001": [
	"The table has reached its maximum size. You cannot insert additional columns."
],
	"\u0000Views\u0001": [
	"Views"
],
	"\u0000View master\u0001": [
	"View master"
],
	"\u0000View master & layout slides\u0001": [
	"View master & layout slides"
],
	"\u0000Insert Drawing\u0001": [
	"Insert Drawing"
],
	"\u0000Tab stop\u0001": [
	"Tab stop"
],
	"\u0000Insert tab stop\u0001": [
	"Insert tab stop"
],
	"\u0000Duplicate\u0001": [
	"Duplicate"
],
	"\u0000Duplicate selected slides\u0001": [
	"Duplicate selected slides"
],
	"\u0000Hide\u0001": [
	"Hide"
],
	"\u0000Start presentation\u0001": [
	"Start presentation"
],
	"\u0000Start the presentation\u0001": [
	"Start the presentation"
],
	"\u0000Full screen\u0001": [
	"Full screen"
],
	"\u0000Show the presentation in full screen mode\u0001": [
	"Show the presentation in full screen mode"
],
	"\u0000Check spelling\u0001": [
	"Check spelling"
],
	"\u0000More review actions\u0001": [
	"More review actions"
],
	"\u0000Check spelling permanently\u0001": [
	"Check spelling permanently"
],
	"\u0000Insert row\u0001": [
	"Insert row"
],
	"\u0000Delete selected rows\u0001": [
	"Delete selected rows"
],
	"\u0000Insert column\u0001": [
	"Insert column"
],
	"\u0000Delete selected columns\u0001": [
	"Delete selected columns"
],
	"\u0000Cell fill color\u0001": [
	"Cell fill colour"
],
	"\u0000Cell border width\u0001": [
	"Cell border width"
],
	"\u0000Borders\u0001": [
	"Borders"
],
	"\u0000Off\u0001": [
	"Off"
],
	"\u0000Turn automatic resizing of text frames off\u0001": [
	"Turn automatic re-sizing of text frames off"
],
	"\u0000Shrink text\u0001": [
	"Shrink text"
],
	"\u0000Turn automatic shrink text on overflow on\u0001": [
	"Turn automatic shrink text on overflow on"
],
	"\u0000Resize frame\u0001": [
	"Re-size frame"
],
	"\u0000Turn automatic height resizing of text frames on\u0001": [
	"Turn automatic height re-sizing of text frames on"
],
	"\u0000Options\u0001": [
	"Options"
],
	"\u0000More options\u0001": [
	"More options"
],
	"\u0000Autofit\u0001": [
	"Auto fit"
],
	"\u0000Resize\u0001": [
	"Re-size"
],
	"\u0000Lock ratio\u0001": [
	"Lock ratio"
],
	"\u0000Lock or unlock the drawing aspect ratio\u0001": [
	"Lock or unlock the drawing aspect ratio"
],
	"\u0000Start local presentation\u0001": [
	"Start local presentation"
],
	"\u0000View the presentation on your device.\u0001": [
	"View the presentation on your device."
],
	"\u0000Start remote presentation\u0001": [
	"Start remote presentation"
],
	"\u0000Broadcast your presentation over the Web.\u0001": [
	"Broadcast your presentation over the Web."
],
	"\u0000Close Presenter\u0001": [
	"Close Presenter"
],
	"\u0000A general error occurred. Please try to reload the document. In case this does not help, please contact your system administrator.\u0001": [
	"A general error occurred. Please try to reload the document. If this does not help, please contact your system administrator."
],
	"\u0000A general network error occurred. Please try to reload the document. In case this does not help, please contact your system administrator.\u0001": [
	"A general network error occurred. Please try to reload the document. If this does not help, please contact your system administrator."
],
	"\u0000A general file storage error occurred. Please try to reload the document. In case this does not help, please contact your system administrator.\u0001": [
	"A general file storage error occurred. Please try to reload the document. If this does not help, please contact your system administrator."
],
	"\u0000The requested document does not exist.\u0001": [
	"The requested document does not exist."
],
	"\u0000The presentation cannot be started. Please check the URL or contact the presenter.\u0001": [
	"The presentation cannot be started. Please check the URL or contact the presenter."
],
	"\u0000This document does not have any content.\u0001": [
	"This document does not have any content."
],
	"\u0000You do not have the appropriate permissions to read the document.\u0001": [
	"You do not have the appropriate permissions to read the document."
],
	"\u0000A general network error occurred. Please contact your system administrator.\u0001": [
	"A general network error occurred. Please contact your system administrator."
],
	"\u0000The maximum number of participants for this presentation has been reached. Joining is not possible.\u0001": [
	"The maximum number of participants for this presentation has been reached. Joining is not possible."
],
	"\u0000The remote presentation cannot be started, because the document is currently being edited in collaboration. Please try again later.\u0001": [
	"The remote presentation cannot be started, because the document is currently being edited in collaboration. Please try again later."
],
	"\u0000The remote presentation cannot be started, because a presentation is already being presented. Please try again later.\u0001": [
	"The remote presentation cannot be started, because the presentation is already in progress. Please try again later."
],
	"\u0000A remote presentation cannot be started, because a needed service is not enabled. Please contact your system administrator.\u0001": [
	"A remote presentation cannot be started, because a needed service is not enabled. Please contact your system administrator."
],
	"\u0000Next slide\u0001": [
	"Next slide"
],
	"\u0000Previous slide\u0001": [
	"Previous slide"
],
	"\u0000Pause\u0001": [
	"Pause"
],
	"\u0000Pause presentation\u0001": [
	"Pause presentation"
],
	"\u0000Pause the presentation\u0001": [
	"Pause the presentation"
],
	"\u0000Continue\u0001": [
	"Continue"
],
	"\u0000Continue presentation\u0001": [
	"Continue presentation"
],
	"\u0000Continue the presentation\u0001": [
	"Continue the presentation"
],
	"\u0000Toggle fullscreen\u0001": [
	"Toggle fullscreen"
],
	"\u0000Presenter navigation bar\u0001": [
	"Presenter navigation bar"
],
	"\u0000of %1$d\u0001": [
	"of %1$d"
],
	"\u0000Jump to slide\u0001": [
	"Jump to slide"
],
	"\u0000none\u0001": [
	"none"
],
	"\u0000Participants\u0001": [
	"Participants"
],
	"\u0000Presenter\u0001": [
	"Presenter"
],
	"\u0000View participants\u0001": [
	"View participants"
],
	"\u0000Presentation start\u0001": [
	"Presentation start"
],
	"\u0000%1$s has started the presentation.\u0001": [
	"%1$s has started the presentation."
],
	"\u0000Join Presentation\u0001": [
	"Join Presentation"
],
	"\u0000Presentation end\u0001": [
	"Presentation end"
],
	"\u0000%1$s has ended the presentation.\u0001": [
	"%1$s has ended the presentation."
],
	"\u0000Presentation join\u0001": [
	"Presentation join"
],
	"\u0000Joining the presentation of %1$s.\u0001": [
	"Joining the presentation of %1$s."
],
	"\u0000The limit of participants has been reached. Please contact the presenter %1$s.\u0001": [
	"The limit of participants has been reached. Please contact the presenter %1$s."
],
	"\u0000The presentation document %1$s was deleted.\u0001": [
	"The presentation document %1$s was deleted."
],
	"\u0000The realtime connection is established.\u0001": [
	"The realtime connection is established."
],
	"\u0000The realtime connection is lost.\u0001": [
	"The realtime connection is lost."
],
	"\u0000There are currently no participants.\u0001": [
	"There are currently no participants."
],
	"\u0000End of Slides\u0001": [
	"End of Slides"
],
	"\u0000Presentation is paused.\u0001": [
	"Presentation is paused."
],
	"\u0000Leave presentation\u0001": [
	"Leave presentation"
],
	"\u0000Leave\u0001": [
	"Leave"
],
	"\u0000%1$d of %2$d\u0001": [
	"%1$d of %2$d"
],
	"\u0000%1$d %\u0001": [
	"%1$d %"
],
	"\u0000Start\u0001": [
	"Start"
],
	"\u0000End\u0001": [
	"End"
],
	"\u0000End presentation\u0001": [
	"End presentation"
],
	"\u0000End the presentation\u0001": [
	"End the presentation"
],
	"\u0000Join\u0001": [
	"Join"
],
	"\u0000Join presentation\u0001": [
	"Join presentation"
],
	"\u0000Join the presentation\u0001": [
	"Join the presentation"
],
	"\u0000Leave the presentation\u0001": [
	"Leave the presentation"
],
	"\u0000Save\u0001": [
	"Save"
],
	"\u0000Unsupported spell checker notification\u0001": [
	"Unsupported spell checker notification"
],
	"\u0000Suppress missing spell checker warnings for the following languages:\u0001": [
	"Suppress missing spell checker warnings for the following languages:"
],
	"\u0000User dictionary\u0001": [
	"User dictionary"
],
	"\u0000Add a new word\u0001": [
	"Add a new word"
],
	"\u0000Add\u0001": [
	"Add"
],
	"\u0000Delete word\u0001": [
	"Delete word"
],
	"\u0000Documents\u0001": [
	"Documents"
],
	"\u0000Documents settings\u0001": [
	"Documents settings"
],
	"\u0000Measurements\u0001": [
	"Measurements"
],
	"\u0000Show measurements in units of\u0001": [
	"Show measurements in units of"
],
	"\u0000Show measurements in units of inch, centimeter, or millimeter\u0001": [
	"Show measurements in units of inch, centimeter, or millimeter"
],
	"\u0000centimeter\u0001": [
	"centimeter"
],
	"\u0000millimeter\u0001": [
	"millimeter"
],
	"\u0000inch\u0001": [
	"inch"
],
	"\u0000Spell checking\u0001": [
	"Spell checking"
],
	"\u0000Check for errors permanently\u0001": [
	"Check for errors permanently"
],
	"\u0000Edit user dictionary\u0001": [
	"Edit user dictionary"
],
	"\u0000Set language notification\u0001": [
	"Set language notification"
],
	"\u0000Theme\u0001": [
	"Theme"
],
	"\u0000Use %1$s theme in editors\u0001": [
	"Use %1$s theme in editors"
],
	"\u0000My template folders\u0001": [
	"My template folders"
],
	"\u0000Global template folders\u0001": [
	"Global template folders"
],
	"\u0000Select template folder\u0001": [
	"Select template folder"
],
	"\u0000Add new template folder\u0001": [
	"Add new template folder"
],
	"\u0000Permissions\u0001": [
	"Permissions"
],
	"\u0000To grant users access to all templates in this folder, please use the Permission dialog. All users need to be able to read all objects in this folder.\u0001": [
	"To grant users access to all templates in this folder, please use the Permission dialogue. All users need to be able to read all objects in this folder."
],
	"\u0000Data references are located on different sheets.\u0001": [
	"Data references are located on different sheets."
],
	"\u0000Data references are too complex for this operation.\u0001": [
	"Data references are too complex for this operation."
],
	"\u0000Select source data\u0001": [
	"Select source data"
],
	"\u0000All comments on this sheet will be removed. Do you want to continue?\u0001": [
	"All comments on this sheet will be removed. Do you want to continue?"
],
	"\u0000Delete notes\u0001": [
	"Delete notes"
],
	"\u0000All notes on this sheet will be removed. Do you want to continue?\u0001": [
	"All notes on this sheet will be removed. Do you want to continue?"
],
	"\u0000Delete sheet\u0001": [
	"Delete sheet"
],
	"\u0000Deleting a sheet cannot be undone. Proceed operation?\u0001": [
	"Deleting a sheet cannot be undone. Proceed with the operation?"
],
	"\u0000Copy sheet\u0001": [
	"Copy sheet"
],
	"\u0000Rename sheet\u0001": [
	"Rename sheet"
],
	"\u0000Rename\u0001": [
	"Rename"
],
	"\u0000Sorting\u0001": [
	"Sorting"
],
	"\u0000Expand the selection?\u0001": [
	"Expand the selection?"
],
	"funchelp\u0000argument%1$d\u0001": [
	"argument%1$d"
],
	"funchelp-HYPGEOM.DIST\u0000cumulative\u0001": [
	"cumulative"
],
	"funchelp-HYPGEOM.DIST\u0000If set to TRUE, calculates the cumulative distribution function; if set to FALSE, calculates the probability density function.\u0001": [
	"If set to TRUE, calculates the cumulative distribution function; if set to FALSE, calculates the probability density function."
],
	"funchelp-NEGBINOM.DIST\u0000cumulative\u0001": [
	"cumulative"
],
	"funchelp-NEGBINOM.DIST\u0000If set to TRUE, calculates the cumulative distribution function; if set to FALSE, calculates the probability density function.\u0001": [
	"If set to TRUE, calculates the cumulative distribution function; if set to FALSE, calculates the probability density function."
],
	"funchelp-NORM.S.DIST\u0000cumulative\u0001": [
	"cumulative"
],
	"funchelp-NORM.S.DIST\u0000If set to TRUE, calculates the cumulative distribution function; if set to FALSE, calculates the probability density function.\u0001": [
	"If set to TRUE, calculates the cumulative distribution function; if set to FALSE, calculates the probability density function."
],
	"funchelp-NUMBERVALUE\u0000group_separator\u0001": [
	"group_separator"
],
	"funchelp-NUMBERVALUE\u0000Defines the character used to separate groups of numbers (e.g. thousands, millions).\u0001": [
	"Defines the character used to separate groups of numbers (e.g.: thousands, millions)."
],
	"funchelp-PERCENTRANK.INC\u0000significance\u0001": [
	"significance"
],
	"funchelp-PERCENTRANK.INC\u0000The number of significant digits to round the returned value to.\u0001": [
	"The number of significant digits to round the returned value to."
],
	"\u0000Sheet%1$d\u0001": [
	"Sheet%1$d"
],
	"filter\u0000Table\u0001": [
	"Table"
],
	"filter\u0000Column\u0001": [
	"Column"
],
	"\u0000Sheet \"%1$s\" activated.\u0001": [
	"Sheet \"%1$s\" activated."
],
	"\u0000%1$d drawing object selected.\u0001%1$d drawing objects selected.": [
	"%1$d drawing object selected.",
	"%1$d drawing objects selected."
],
	"\u0000%1$d cell range selected.\u0001%1$d cell ranges selected.": [
	"%1$d cell range selected.",
	"%1$d cell ranges selected."
],
	"\u0000Columns %1$s to %2$s selected.\u0001": [
	"Columns %1$s to %2$s selected."
],
	"\u0000Rows %1$s to %2$s selected.\u0001": [
	"Rows %1$s to %2$s selected."
],
	"\u0000%1$s to %2$s selected.\u0001": [
	"%1$s to %2$s selected."
],
	"\u0000It is not possible to create a chart out of more than 50 input cells.\u0001": [
	"It is not possible to create a chart out of more than 50 input cells."
],
	"\u0000Scroll to the previous sheet\u0001": [
	"Scroll to the previous sheet"
],
	"\u0000Scroll to the next sheet\u0001": [
	"Scroll to the next sheet"
],
	"\u0000Select sheet\u0001": [
	"Select sheet"
],
	"\u0000Horizontal alignment\u0001": [
	"Horizontal alignment"
],
	"\u0000Vertical alignment\u0001": [
	"Vertical alignment"
],
	"\u0000Cell style\u0001": [
	"Cell style"
],
	"number-format\u0000%1$s (%2$s)\u0001": [
	"%1$s (%2$s)"
],
	"number-format\u0000%1$s (%2$s, hidden symbol)\u0001": [
	"%1$s (%2$s, hidden symbol)"
],
	"number-format\u0000Leave empty space for currency symbol\u0001": [
	"Leave empty space for currency symbol"
],
	"number-format\u0000%1$s (%2$s, %3$s)\u0001": [
	"%1$s (%2$s, %3$s)"
],
	"filter\u0000Blank cells\u0001": [
	"Blank cells"
],
	"\u0000Number formats\u0001": [
	"Number formats"
],
	"\u0000Number format\u0001": [
	"Number format"
],
	"number-format\u0000More number formats\u0001": [
	"More number formats"
],
	"\u0000Merge or unmerge cells\u0001": [
	"Merge or unmerge cells"
],
	"\u0000Merge cells\u0001": [
	"Merge cells"
],
	"\u0000Merge cells horizontally\u0001": [
	"Merge cells horizontally"
],
	"\u0000Merge cells vertically\u0001": [
	"Merge cells vertically"
],
	"\u0000Unmerge cells\u0001": [
	"Unmerge cells"
],
	"named ranges\u0000Named ranges\u0001": [
	"Named ranges"
],
	"named ranges\u0000Show or hide the named ranges in this document\u0001": [
	"Show or hide the named ranges in this document"
],
	"named ranges\u0000Add new range\u0001": [
	"Add new range"
],
	"named ranges\u0000Add a named range\u0001": [
	"Add a named range"
],
	"sort\u0000Sorting\u0001": [
	"Sorting"
],
	"\u0000Type of the subtotal value\u0001": [
	"Type of the subtotal value"
],
	"\u0000Sum: %1$s\u0001": [
	"Sum: %1$s"
],
	"\u0000Sum of selected cells\u0001": [
	"Sum of selected cells"
],
	"\u0000Min: %1$s\u0001": [
	"Min: %1$s"
],
	"\u0000Minimum value in selection\u0001": [
	"Minimum value in selection"
],
	"\u0000Max: %1$s\u0001": [
	"Max: %1$s"
],
	"\u0000Maximum value in selection\u0001": [
	"Maximum value in selection"
],
	"\u0000Count: %1$s\u0001": [
	"Count: %1$s"
],
	"\u0000Number of selected cells that contain data\u0001": [
	"Number of selected cells that contain data"
],
	"\u0000Numerical count: %1$s\u0001": [
	"Numerical count: %1$s"
],
	"\u0000Number of selected cells that contain numerical data\u0001": [
	"Number of selected cells that contain numerical data"
],
	"\u0000Average: %1$s\u0001": [
	"Average: %1$s"
],
	"\u0000Average of selected cells\u0001": [
	"Average of selected cells"
],
	"\u0000Delete row\u0001": [
	"Delete row"
],
	"\u0000Delete column\u0001": [
	"Delete column"
],
	"\u0000Insert rows\u0001": [
	"Insert rows"
],
	"\u0000Insert columns\u0001": [
	"Insert columns"
],
	"\u0000Column width\u0001": [
	"Column width"
],
	"\u0000Row height\u0001": [
	"Row height"
],
	"borders\u0000Double line\u0001": [
	"Double line"
],
	"borders\u0000Single\u0001": [
	"Single"
],
	"borders\u0000Double\u0001": [
	"Double"
],
	"borders\u0000Dotted\u0001": [
	"Dotted"
],
	"borders\u0000Dashed\u0001": [
	"Dashed"
],
	"\u0000Cell protection\u0001": [
	"Cell protection"
],
	"\u0000Change cell protection for the selected cells\u0001": [
	"Change cell protection for the selected cells"
],
	"\u0000Unlock cell\u0001": [
	"Unlock cell"
],
	"\u0000Unlock the cell in protected sheets\u0001": [
	"Unlock the cell in protected sheets"
],
	"\u0000Lock cell\u0001": [
	"Lock cell"
],
	"\u0000Lock the cell in protected sheets\u0001": [
	"Lock the cell in protected sheets"
],
	"\u0000Unhide formula\u0001": [
	"Unhide formula"
],
	"\u0000Unhide the formula in protected sheets\u0001": [
	"Unhide the formula in protected sheets"
],
	"\u0000Hide formula\u0001": [
	"Hide formula"
],
	"\u0000Hide the formula in protected sheets\u0001": [
	"Hide the formula in protected sheets"
],
	"\u0000Note\u0001": [
	"Note"
],
	"\u0000Note-Handling\u0001": [
	"Note-Handling"
],
	"\u0000Comment-Handling\u0001": [
	"Comment-Handling"
],
	"\u0000Toggle visibility of selected note\u0001": [
	"Toggle visibility of selected note"
],
	"\u0000Toggle visibility of selected comment\u0001": [
	"Toggle visibility of selected comment"
],
	"\u0000Delete selected note\u0001": [
	"Delete selected note"
],
	"\u0000Delete selected comment\u0001": [
	"Delete selected comment"
],
	"\u0000Show/Hide\u0001": [
	"Show/Hide"
],
	"sheet-split\u0000Split sheet\u0001": [
	"Split sheet"
],
	"sheet-split\u0000Split the sheet above and left of the current cursor position\u0001": [
	"Split the sheet above and left of the current cursor position"
],
	"sheet-split\u0000Freeze sheet\u0001": [
	"Freeze sheet"
],
	"sheet-split\u0000Freeze the rows above and the columns left of the cursor\u0001": [
	"Freeze the rows above and the columns left of the cursor"
],
	"\u0000Freeze first row\u0001": [
	"Freeze first row"
],
	"\u0000Freeze the first visible row\u0001": [
	"Freeze the first visible row"
],
	"\u0000Freeze first column\u0001": [
	"Freeze first column"
],
	"\u0000Freeze the first visible column\u0001": [
	"Freeze the first visible column"
],
	"\u0000Freeze first row and column\u0001": [
	"Freeze first row and column"
],
	"\u0000Freeze the first visible row and the first visible column\u0001": [
	"Freeze the first visible row and the first visible column"
],
	"\u0000Sum\u0001": [
	"Sum"
],
	"\u0000Sum automatically\u0001": [
	"Sum automatically"
],
	"\u0000Function\u0001": [
	"Function"
],
	"\u0000Insert function at cursor location\u0001": [
	"Insert function at cursor location"
],
	"filter\u0000Filter\u0001": [
	"Filter"
],
	"\u0000Filter the selected cells\u0001": [
	"Filter the selected cells"
],
	"filter\u0000Reapply\u0001": [
	"Reapply"
],
	"\u0000Reapply the filter in the selected cells\u0001": [
	"Reapply the filter in the selected cells"
],
	"\u0000No Style, No Grid\u0001": [
	"No Style, No Grid"
],
	"number-format\u0000Custom currency format\u0001": [
	"Custom currency format"
],
	"number-format\u0000Currency symbol\u0001": [
	"Currency symbol"
],
	"number-format\u0000Decimal digits\u0001": [
	"Decimal digits"
],
	"number-format\u0000Use thousands separator\u0001": [
	"Use thousands separator"
],
	"number-format\u0000Use accounting format\u0001": [
	"Use accounting format"
],
	"number-format\u0000Use ISO currency code\u0001": [
	"Use ISO currency code"
],
	"number-format\u0000Red text color for negative numbers\u0001": [
	"Red text colour for negative numbers"
],
	"\u0000Preview\u0001": [
	"Preview"
],
	"number-format\u0000Positive\u0001": [
	"Positive"
],
	"number-format\u0000Negative\u0001": [
	"Negative"
],
	"number-format\u0000Zero\u0001": [
	"Zero"
],
	"sort\u0000All sort criteria must have a column or row specified.\u0001": [
	"All sort criteria must have a column or row specified."
],
	"sort\u0000Some columns or rows are being sorted more than once.\u0001": [
	"Some columns or rows are being sorted more than once."
],
	"sort\u0000Options\u0001": [
	"Options"
],
	"sort\u0000Selection has headers\u0001": [
	"Selection has headers"
],
	"sort\u0000Add sort criteria\u0001": [
	"Add sort criteria"
],
	"sort\u0000Direction\u0001": [
	"Direction"
],
	"sort\u0000Sort by\u0001": [
	"Sort by"
],
	"sort\u0000Order\u0001": [
	"Order"
],
	"sort\u0000undefined\u0001": [
	"undefined"
],
	"sort\u0000Top to bottom\u0001": [
	"Top to bottom"
],
	"sort\u0000Left to right\u0001": [
	"Left to right"
],
	"sort\u0000Custom sort\u0001": [
	"Custom sort"
],
	"\u0000Sort\u0001": [
	"Sort"
],
	"\u0000Change name\u0001": [
	"Change name"
],
	"\u0000Insert name\u0001": [
	"Insert name"
],
	"\u0000Change\u0001": [
	"Change"
],
	"\u0000Enter name\u0001": [
	"Enter name"
],
	"\u0000Name\u0001": [
	"Name"
],
	"\u0000Enter formula\u0001": [
	"Enter formula"
],
	"\u0000Formula\u0001": [
	"Formula"
],
	"function-dialog\u0000Pick a category\u0001": [
	"Pick a category"
],
	"function-dialog\u0000All\u0001": [
	"All"
],
	"function-dialog\u0000Pick a function\u0001": [
	"Pick a function"
],
	"function-dialog\u0000Syntax\u0001": [
	"Syntax"
],
	"function-dialog\u0000Parameters\u0001": [
	"Parameters"
],
	"function-dialog\u0000%1$s (optional)\u0001": [
	"%1$s (optional)"
],
	"function-dialog\u0000Insert function\u0001": [
	"Insert function"
],
	"function-dialog\u0000Insert\u0001": [
	"Insert"
],
	"\u0000Reorder sheets\u0001": [
	"Reorder sheets"
],
	"\u0000Move to top\u0001": [
	"Move to top"
],
	"\u0000Move up\u0001": [
	"Move up"
],
	"\u0000Move down\u0001": [
	"Move down"
],
	"\u0000Move to bottom\u0001": [
	"Move to bottom"
],
	"\u0000Enter sheet name\u0001": [
	"Enter sheet name"
],
	"\u0000Unhide sheets\u0001": [
	"Unhide sheets"
],
	"\u0000Table ranges\u0001": [
	"Table ranges"
],
	"\u0000Functions\u0001": [
	"Functions"
],
	"\u0000Insert mode\u0001": [
	"Insert mode"
],
	"\u0000Edit mode\u0001": [
	"Edit mode"
],
	"menu-title\u0000Rows/Columns\u0001": [
	"Rows/Columns"
],
	"menu-title\u0000Cells\u0001": [
	"Cells"
],
	"menu-title\u0000Data\u0001": [
	"Data"
],
	"menu-title\u0000Filter\u0001": [
	"Filter"
],
	"menu-title\u0000Sort\u0001": [
	"Sort"
],
	"\u0000Insert sheet\u0001": [
	"Insert sheet"
],
	"\u0000Unprotect sheet\u0001": [
	"Unprotect sheet"
],
	"\u0000Protect sheet\u0001": [
	"Protect sheet"
],
	"\u0000Show sheet\u0001": [
	"Show sheet"
],
	"\u0000Hide sheet\u0001": [
	"Hide sheet"
],
	"\u0000Automatic word wrap\u0001": [
	"Automatic word wrap"
],
	"\u0000Delete decimal place\u0001": [
	"Delete decimal place"
],
	"\u0000Add decimal place\u0001": [
	"Add decimal place"
],
	"function-category\u0000Complex numbers\u0001": [
	"Complex numbers"
],
	"function-category\u0000Conversion\u0001": [
	"Conversion"
],
	"function-category\u0000Database\u0001": [
	"Database"
],
	"function-category\u0000Date and time\u0001": [
	"Date and time"
],
	"function-category\u0000Engineering\u0001": [
	"Engineering"
],
	"function-category\u0000Financial\u0001": [
	"Financial"
],
	"function-category\u0000Information\u0001": [
	"Information"
],
	"function-category\u0000Logical\u0001": [
	"Logical"
],
	"function-category\u0000Mathematical\u0001": [
	"Mathematical"
],
	"function-category\u0000Matrix\u0001": [
	"Matrix"
],
	"function-category\u0000Reference\u0001": [
	"Reference"
],
	"function-category\u0000Statistical\u0001": [
	"Statistical"
],
	"function-category\u0000Text\u0001": [
	"Text"
],
	"function-category\u0000Web\u0001": [
	"Web"
],
	"number-format\u0000Custom ...\u0001": [
	"Custom ..."
],
	"number-format\u0000Currency ...\u0001": [
	"Currency ..."
],
	"sort\u0000Ascending\u0001": [
	"Ascending"
],
	"sort\u0000Sort from smallest to largest value\u0001": [
	"Sort from smallest to largest value"
],
	"sort\u0000Descending\u0001": [
	"Descending"
],
	"sort\u0000Sort from largest to smallest value\u0001": [
	"Sort from largest to smallest value"
],
	"sort\u0000Custom\u0001": [
	"Custom"
],
	"sort\u0000Settings for sorting\u0001": [
	"Settings for sorting"
],
	"\u0000Clear contents\u0001": [
	"Clear contents"
],
	"number-format\u0000General\u0001": [
	"General"
],
	"number-format\u0000Number\u0001": [
	"Number"
],
	"number-format\u0000Currency\u0001": [
	"Currency"
],
	"number-format\u0000Accounting\u0001": [
	"Accounting"
],
	"number-format\u0000Date\u0001": [
	"Date"
],
	"number-format\u0000Time\u0001": [
	"Time"
],
	"number-format\u0000Date and time\u0001": [
	"Date and time"
],
	"number-format\u0000Percentage\u0001": [
	"Percentage"
],
	"number-format\u0000Scientific\u0001": [
	"Scientific"
],
	"number-format\u0000Fraction\u0001": [
	"Fraction"
],
	"number-format\u0000Text\u0001": [
	"Text"
],
	"number-format\u0000Custom\u0001": [
	"Custom"
],
	"\u0000Calculating\u0001": [
	"Calculating"
],
	"\u0000Column %1$s\u0001": [
	"Column %1$s"
],
	"\u0000Row %1$s\u0001": [
	"Row %1$s"
],
	"\u0000Cell %1$s\u0001": [
	"Cell %1$s"
],
	"\u0000Series %1$d\u0001": [
	"Series %1$d"
],
	"\u0000The sheet name must not be empty. Please enter a name.\u0001": [
	"The sheet name must not be empty. Please enter a name."
],
	"\u0000This sheet name contains invalid characters. Please ensure that the name does not contain / \\ * ? : [ or ], and does neither start nor end with an apostrophe.\u0001": [
	"This sheet name contains invalid characters. Please ensure that the name does not contain / \\ * ? : [ or ], and does not start or end with an apostrophe."
],
	"\u0000This sheet name is already used. Please enter another name.\u0001": [
	"This sheet name is already used. Please enter another name."
],
	"\u0000You cannot use this command on a protected sheet.\u0001": [
	"You cannot use this command on a protected sheet."
],
	"\u0000Please select only entire columns, or just some cells in the sheet.\u0001": [
	"Please only select only columns, or just some cells in the sheet."
],
	"\u0000It is not possible to modify more than %1$d columns at the same time.\u0001": [
	"It is not possible to modify more than %1$d columns at the same time."
],
	"\u0000Please select only entire rows, or just some cells in the sheet.\u0001": [
	"Please select only entire rows, or just some cells in the sheet."
],
	"\u0000It is not possible to modify more than %1$d rows at the same time.\u0001": [
	"It is not possible to modify more than %1$d rows at the same time."
],
	"\u0000Protected cells cannot be modified.\u0001": [
	"Protected cells cannot be modified."
],
	"\u0000It is not possible to modify more than %1$d cells at the same time.\u0001": [
	"It is not possible to modify more than %1$d cells at the same time."
],
	"\u0000It is not possible to insert new cells because non-empty cells would be pushed off the end of the sheet.\u0001": [
	"It is not possible to insert new cells because non-empty cells would be pushed off the end of the sheet."
],
	"\u0000Overlapping ranges cannot be merged.\u0001": [
	"Overlapping ranges cannot be merged."
],
	"\u0000It is not possible to merge more than %1$d ranges at the same time.\u0001": [
	"It is not possible to merge more than %1$d ranges at the same time."
],
	"\u0000Autofill over merged cells is not allowed.\u0001": [
	"Auto-fill over merged cells is not allowed."
],
	"\u0000This name contains invalid characters. Please enter another name.\u0001": [
	"This name contains invalid characters. Please enter another name."
],
	"\u0000A cell address cannot be used as name. Please enter another name.\u0001": [
	"A cell address cannot be used as a name. Please enter another name."
],
	"\u0000This name is already used. Please enter another name.\u0001": [
	"This name is already used. Please enter another name."
],
	"\u0000Table cannot be created on multiple cell ranges.\u0001": [
	"Table cannot be created on multiple cell ranges."
],
	"\u0000Table cannot be created on another filtered range.\u0001": [
	"Table cannot be created on another filtered range."
],
	"\u0000Parts of a table cannot be moved.\u0001": [
	"Parts of a table cannot be moved."
],
	"\u0000Parts of a table cannot be changed.\u0001": [
	"Parts of a table cannot be changed."
],
	"\u0000The header cells of a table cannot be changed.\u0001": [
	"The header cells of a table cannot be changed."
],
	"\u0000Filter cannot be applied to multiple cell ranges.\u0001": [
	"Filter cannot be applied to multiple cell ranges."
],
	"\u0000Filter cannot be applied to another filtered range.\u0001": [
	"Filter cannot be applied to another filtered range."
],
	"\u0000Filtering cannot be performed on blank cells.\u0001": [
	"Filtering cannot be performed on blank cells."
],
	"\u0000Parts of the filter cannot be moved.\u0001": [
	"Parts of the filter cannot be moved."
],
	"\u0000Sorting cannot be performed on multiple cell ranges.\u0001": [
	"Sorting cannot be performed on multiple cell ranges."
],
	"\u0000Sorting cannot be performed on blank cells.\u0001": [
	"Sorting cannot be performed on blank cells."
],
	"\u0000Sorting cannot be performed on more than %1$d columns or rows.\u0001": [
	"Sorting cannot be performed on more than %1$d columns or rows."
],
	"\u0000Sorting over merged cells is not allowed.\u0001": [
	"Sorting over merged cells is not allowed."
],
	"\u0000No results for your search.\u0001": [
	"No results for your search."
],
	"\u0000No more results for your search.\u0001": [
	"No more results for your search."
],
	"\u0000Nothing to replace.\u0001": [
	"Nothing to replace."
],
	"\u0000The formula contains an error.\u0001": [
	"The formula contains an error."
],
	"\u0000Parts of a matrix formula cannot be changed.\u0001": [
	"Parts of a matrix formula cannot be changed."
],
	"\u0000It is not possible to insert cells into a matrix formula.\u0001": [
	"It is not possible to insert cells into a matrix formula."
],
	"\u0000Parts of a matrix formula cannot be deleted.\u0001": [
	"Parts of a matrix formula cannot be deleted."
],
	"\u0000It is not possible to insert a matrix formula with more than %1$d elements.\u0001": [
	"It is not possible to insert a matrix formula with more than %1$d elements."
],
	"\u0000It is not possible to insert a matrix formula over merged cells.\u0001": [
	"It is not possible to insert a matrix formula over merged cells."
],
	"\u0000No source data available for the drop-down list.\u0001": [
	"No source data available for the drop-down list."
],
	"\u0000It is not possible to copy more than %1$d cells at the same time.\u0001": [
	"It is not possible to copy more than %1$d cells at the same time."
],
	"\u0000It is not possible to paste more than %1$d cells at the same time.\u0001": [
	"It is not possible to paste more than %1$d cells at the same time."
],
	"\u0000It is not possible to paste outside of the valid sheet area.\u0001": [
	"It is not possible to paste outside of the valid sheet area."
],
	"\u0000Pasting into protected cells is not allowed.\u0001": [
	"Pasting into protected cells is not allowed."
],
	"\u0000You cannot paste this here because the copy area and paste area are not the same size. Select just one cell in the paste area or an area with the same size, and try pasting again.\u0001": [
	"You cannot paste this here because the copy area and paste area are not the same size. Select one cell in the paste area or an area with the same size, and try pasting again."
],
	"\u0000File type not supported.\u0001": [
	"File type not supported."
],
	"\u0000Objects cannot be inserted into a protected sheet.\u0001": [
	"Objects cannot be inserted into a protected sheet."
],
	"\u0000Objects on a protected sheet cannot be deleted.\u0001": [
	"Objects on a protected sheet cannot be deleted."
],
	"\u0000Objects on a protected sheet cannot be changed.\u0001": [
	"Objects on a protected sheet cannot be changed."
],
	"\u0000Notes cannot be inserted into a protected sheet.\u0001": [
	"Notes cannot be inserted into a protected sheet."
],
	"\u0000Comments cannot be inserted into a protected sheet.\u0001": [
	"Comments cannot be inserted into a protected sheet."
],
	"\u0000Notes on a protected sheet cannot be deleted.\u0001": [
	"Notes on a protected sheet cannot be deleted."
],
	"\u0000Comments on a protected sheet cannot be deleted.\u0001": [
	"Comments on a protected sheet cannot be deleted."
],
	"\u0000Notes on a protected sheet cannot be changed.\u0001": [
	"Notes on a protected sheet cannot be changed."
],
	"\u0000Comments on a protected sheet cannot be changed.\u0001": [
	"Comments on a protected sheet cannot be changed."
],
	"\u0000No more notes found.\u0001": [
	"No more notes found."
],
	"\u0000No more comments found.\u0001": [
	"No more comments found."
],
	"\u0000The search continues from the beginning of this document.\u0001": [
	"The search continues from the beginning of this document."
],
	"\u0000Collapse formula bar\u0001": [
	"Collapse formula bar"
],
	"\u0000Expand formula bar\u0001": [
	"Expand formula bar"
],
	"\u0000Drag to change column width\u0001": [
	"Drag to change column width"
],
	"\u0000Drag to show hidden column\u0001": [
	"Drag to show hidden column"
],
	"\u0000Drag to change row height\u0001": [
	"Drag to change row height"
],
	"\u0000Drag to show hidden row\u0001": [
	"Drag to show hidden row"
],
	"\u0000More sheet operations\u0001": [
	"More sheet operations"
],
	"\u0000Rows\u0001": [
	"Rows"
],
	"\u0000Row\u0001": [
	"Row"
],
	"\u0000Columns\u0001": [
	"Columns"
],
	"\u0000Column\u0001": [
	"Column"
],
	"\u0000Named range\u0001": [
	"Named range"
],
	"comment-actions\u0000Comment\u0001": [
	"Comment"
],
	"\u0000Unfreeze sheet\u0001": [
	"Unfreeze sheet"
],
	"\u0000Freeze sheet\u0001": [
	"Freeze sheet"
],
	"\u0000Set optimal column width\u0001": [
	"Set optimal column width"
],
	"\u0000Hide columns\u0001": [
	"Hide columns"
],
	"\u0000Hide column\u0001": [
	"Hide column"
],
	"\u0000Show hidden columns\u0001": [
	"Show hidden columns"
],
	"\u0000Set optimal row height\u0001": [
	"Set optimal row height"
],
	"\u0000Hide rows\u0001": [
	"Hide rows"
],
	"\u0000Hide row\u0001": [
	"Hide row"
],
	"\u0000Show hidden rows\u0001": [
	"Show hidden rows"
],
	"\u0000Delete name\u0001": [
	"Delete name"
],
	"named ranges\u0000Add new named range\u0001": [
	"Add new named range"
],
	"named ranges\u0000No named ranges defined.\u0001": [
	"No named ranges defined."
],
	"filter\u0000Select values for filtering or sorting\u0001": [
	"Select values for filtering or sorting"
],
	"\u0000Select a value for this cell\u0001": [
	"Select a value for this cell"
],
	"\u0000Circular Reference\u0001": [
	"Circular Reference"
],
	"\u0000A reference in the formula is dependent on the result of the formula cell.\u0001": [
	"A reference in the formula is dependent on the result of the formula cell."
],
	"\u0000This document exceeds the spreadsheet size and complexity limits. Calculation has been stopped. Formula results are not updated anymore.\u0001": [
	"This document exceeds the spreadsheet size and complexity limits. Calculation has been stopped. Formula results are no longer updated."
],
	"\u0000This spreadsheet contains formulas with unsupported functions:\u0001": [
	"This spreadsheet contains formulas with unsupported functions:"
],
	"\u0000There are no comments on this sheet.\u0001": [
	"There are no comments on this sheet."
],
	"sheet-split\u0000Split and freeze\u0001": [
	"Split and freeze"
],
	"\u0000Show formula bar\u0001": [
	"Show formula bar"
],
	"\u0000Show or hide the formula bar\u0001": [
	"Show or hide the formula bar"
],
	"\u0000Show grid lines\u0001": [
	"Show grid lines"
],
	"\u0000Show or hide the cell grid lines in the current sheet\u0001": [
	"Show or hide the cell grid lines in the current sheet"
],
	"\u0000Show sheet tabs\u0001": [
	"Show sheet tabs"
],
	"\u0000Show or hide the sheet tabs below the sheet area\u0001": [
	"Show or hide the sheet tabs below the sheet area"
],
	"chart-source\u0000Data source\u0001": [
	"Data source"
],
	"chart-source\u0000Edit data references\u0001": [
	"Edit data references"
],
	"chart-source\u0000Switch rows and columns\u0001": [
	"Switch rows and columns"
],
	"chart-source\u0000First row as label\u0001": [
	"First row as label"
],
	"chart-source\u0000First column as label\u0001": [
	"First column as label"
],
	"note-actions\u0000Previous\u0001": [
	"Previous"
],
	"note-actions\u0000Go to previous note\u0001": [
	"Go to previous note"
],
	"note-actions\u0000Next\u0001": [
	"Next"
],
	"note-actions\u0000Go to next note\u0001": [
	"Go to next note"
],
	"note-actions\u0000Show/Hide\u0001": [
	"Show/Hide"
],
	"note-actions\u0000Show/Hide selected note\u0001": [
	"Show/Hide selected note"
],
	"comment-actions\u0000Show/Hide\u0001": [
	"Show/Hide"
],
	"comment-actions\u0000Show/Hide selected comment\u0001": [
	"Show/Hide selected comment"
],
	"note-actions\u0000Delete\u0001": [
	"Delete"
],
	"note-actions\u0000Delete note\u0001": [
	"Delete note"
],
	"comment-actions\u0000Delete comment\u0001": [
	"Delete comment"
],
	"note-actions\u0000Show all\u0001": [
	"Show all"
],
	"note-actions\u0000Show all notes\u0001": [
	"Show all notes"
],
	"comment-actions\u0000Show all\u0001": [
	"Show all"
],
	"comment-actions\u0000Show all comments\u0001": [
	"Show all comments"
],
	"note-actions\u0000Hide all\u0001": [
	"Hide all"
],
	"note-actions\u0000Hide all notes\u0001": [
	"Hide all notes"
],
	"comment-actions\u0000Hide all\u0001": [
	"Hide all"
],
	"comment-actions\u0000Hide all comments\u0001": [
	"Hide all comments"
],
	"note-actions\u0000Delete all\u0001": [
	"Delete all"
],
	"note-actions\u0000Delete all notes\u0001": [
	"Delete all notes"
],
	"comment-actions\u0000Delete all comments\u0001": [
	"Delete all comments"
],
	"\u0000Notes\u0001": [
	"Notes"
],
	"comment-actions\u0000Insert comment\u0001": [
	"Insert comment"
],
	"\u0000Document images could not be processed. Send as mail is not possible.\u0001": [
	"Document images could not be processed. Send as e-mail is not possible."
],
	"\u0000Auto\u0001": [
	"Auto"
],
	"\u0000English\u0001": [
	"English"
],
	"\u0000Dutch\u0001": [
	"Dutch"
],
	"\u0000French\u0001": [
	"French"
],
	"\u0000German\u0001": [
	"German"
],
	"\u0000Italian\u0001": [
	"Italian"
],
	"\u0000Portuguese\u0001": [
	"Portuguese"
],
	"\u0000Spanish\u0001": [
	"Spanish"
],
	"\u0000Inappropriate content detected. Please try again with different input.\u0001": [
	"Inappropriate content detected. Please try again with different input."
],
	"\u0000API request failed. The service might be unavailable. Please try again in a few minutes.\u0001": [
	"API request failed. The service might be unavailable. Please try again in a few minutes."
],
	"\u0000Inserting AI content will take some time, please wait...\u0001": [
	"Inserting AI content will take some time, please wait..."
],
	"\u0000At least one filtered comment will be removed, too. Do you want to continue?\u0001": [
	"At least one filtered comment will be removed, too. Do you want to continue?"
],
	"\u0000All comments in the document will be removed. Do you want to continue?\u0001": [
	"All comments in the document will be removed. Do you want to continue?"
],
	"\u0000The search continues from the end of this document.\u0001": [
	"The search continues from the end of this document."
],
	"\u0000Filled circle\u0001": [
	"Filled circle"
],
	"\u0000Small filled circle\u0001": [
	"Small filled circle"
],
	"\u0000Circle\u0001": [
	"Circle"
],
	"\u0000Small circle\u0001": [
	"Small circle"
],
	"\u0000Filled square\u0001": [
	"Filled square"
],
	"\u0000Small filled square\u0001": [
	"Small filled square"
],
	"\u0000Square\u0001": [
	"Square"
],
	"\u0000Small square\u0001": [
	"Small square"
],
	"\u0000Filled diamond\u0001": [
	"Filled diamond"
],
	"\u0000Diamond\u0001": [
	"Diamond"
],
	"\u0000Filled triangle\u0001": [
	"Filled triangle"
],
	"\u0000Chevron\u0001": [
	"Chevron"
],
	"\u0000Dash\u0001": [
	"Dash"
],
	"\u0000No symbol\u0001": [
	"No symbol"
],
	"\u0000Decimal numbers\u0001": [
	"Decimal numbers"
],
	"\u0000Small Latin letters\u0001": [
	"Small Latin letters"
],
	"\u0000Capital Latin letters\u0001": [
	"Capital Latin letters"
],
	"\u0000Small Roman numbers\u0001": [
	"Small Roman numbers"
],
	"\u0000Capital Roman numbers\u0001": [
	"Capital Roman numbers"
],
	"\u0000Style %1$d\u0001": [
	"Style %1$d"
],
	"\u0000Create paragraph style\u0001": [
	"Create paragraph style"
],
	"\u0000Rename paragraph style \"%1$s\"\u0001": [
	"Rename paragraph style \"%1$s\""
],
	"\u0000Please wait while updating document.\u0001": [
	"Please wait while updating document."
],
	"\u0000Paragraph fill color\u0001": [
	"Paragraph fill colour"
],
	"\u0000Paragraph borders\u0001": [
	"Paragraph borders"
],
	"\u0000Header & footer\u0001": [
	"Header & footer"
],
	"\u0000Insert header & footer in document\u0001": [
	"Insert header & footer in document"
],
	"\u0000Same across entire document\u0001": [
	"Same across entire document"
],
	"\u0000Different first page\u0001": [
	"Different first page"
],
	"\u0000Different even & odd pages\u0001": [
	"Different even & odd pages"
],
	"\u0000Different first, even & odd pages\u0001": [
	"Different first, even & odd pages"
],
	"\u0000Remove all headers and footers\u0001": [
	"Remove all headers and footers"
],
	"\u0000Page number\u0001": [
	"Page number"
],
	"\u0000Page count\u0001": [
	"Page count"
],
	"\u0000Author name\u0001": [
	"Author name"
],
	"\u0000Create, transform or translate content with AI\u0001": [
	"Create, transform or translate content with AI"
],
	"\u0000Report\u0001": [
	"Report"
],
	"\u0000Story\u0001": [
	"Story"
],
	"\u0000Article\u0001": [
	"Article"
],
	"\u0000Essay\u0001": [
	"Essay"
],
	"\u0000Research paper\u0001": [
	"Research paper"
],
	"\u0000Memo\u0001": [
	"Memo"
],
	"\u0000Letter\u0001": [
	"Letter"
],
	"\u0000Resume\u0001": [
	"Resume"
],
	"\u0000Instruction\u0001": [
	"Instruction"
],
	"\u0000Invoice\u0001": [
	"Invoice"
],
	"\u0000Contract\u0001": [
	"Contract"
],
	"\u0000Whitepaper\u0001": [
	"Whitepaper"
],
	"\u0000Newsletter\u0001": [
	"Newsletter"
],
	"\u0000Travel report\u0001": [
	"Travel report"
],
	"\u0000Replace selected text in document\u0001": [
	"Replace selected text in document"
],
	"\u0000Add before selected text in document\u0001": [
	"Add before selected text in document"
],
	"\u0000Add behind selected text in document\u0001": [
	"Add after selected text in document"
],
	"\u0000Generate or transform content\u0001": [
	"Generate or transform content"
],
	"\u0000Generate\u0001": [
	"Generate"
],
	"\u0000Transform\u0001": [
	"Transform"
],
	"\u0000Translate to\u0001": [
	"Translate to"
],
	"\u0000Action\u0001": [
	"Action"
],
	"\u0000Translate from\u0001": [
	"Translate from"
],
	"\u0000Document type\u0001": [
	"Document type"
],
	"\u0000Length\u0001": [
	"Length"
],
	"\u0000Short\u0001": [
	"Short"
],
	"\u0000Medium\u0001": [
	"Medium"
],
	"\u0000Long\u0001": [
	"Long"
],
	"\u0000Tone\u0001": [
	"Tone"
],
	"\u0000Formal\u0001": [
	"Formal"
],
	"\u0000Neutral\u0001": [
	"Neutral"
],
	"\u0000Informal\u0001": [
	"Informal"
],
	"\u0000Mood\u0001": [
	"Mood"
],
	"\u0000Exciting\u0001": [
	"Exciting"
],
	"\u0000Friendly\u0001": [
	"Friendly"
],
	"\u0000Positive\u0001": [
	"Positive"
],
	"\u0000Rejecting\u0001": [
	"Rejecting"
],
	"\u0000Disappointed\u0001": [
	"Disappointed"
],
	"\u0000Please add keywords or text to fine-tune your content!\u0001": [
	"Please add keywords or text to fine-tune your content!"
],
	"\u0000Your input is restricted to the maximum length of %1$d characters!\u0001": [
	"Your input is restricted to the maximum length of %1$d characters!"
],
	"\u0000Generated result\u0001": [
	"Generated result"
],
	"\u0000Your feedback on AI integration ...\u0001": [
	"Your feedback on AI integration ..."
],
	"\u0000Your input\u0001": [
	"Your input"
],
	"\u0000Keywords (optional)\u0001": [
	"Keywords (optional)"
],
	"\u0000%1$d characters remaining\u0001": [
	"%1$d characters remaining"
],
	"\u0000Regenerate\u0001": [
	"Regenerate"
],
	"\u0000Use content\u0001": [
	"Use content"
],
	"\u0000Paragraph\u0001": [
	"Paragraph"
],
	"\u0000Indentation\u0001": [
	"Indentation"
],
	"\u0000Left\u0001": [
	"Left"
],
	"\u0000Set left indent\u0001": [
	"Set left indent"
],
	"\u0000Right\u0001": [
	"Right"
],
	"\u0000Set right indent\u0001": [
	"Set right indent"
],
	"\u0000First line\u0001": [
	"First line"
],
	"\u0000Set paragraph's first line indent\u0001": [
	"Set paragraph's first line indent"
],
	"\u0000Page %1$d\u0001": [
	"Page %1$d"
],
	"\u0000Page %1$d of %2$d\u0001": [
	"Page %1$d of %2$d"
],
	"\u0000Left indent\u0001": [
	"Left indent"
],
	"\u0000Right indent\u0001": [
	"Right indent"
],
	"\u0000First line indent\u0001": [
	"First line indent"
],
	"\u0000There are no comments in this document.\u0001": [
	"There are no comments in this document."
],
	"change-tracking\u0000Inserted\u0001": [
	"Inserted"
],
	"change-tracking\u0000Deleted\u0001": [
	"Deleted"
],
	"change-tracking\u0000Formatted\u0001": [
	"Formatted"
],
	"change-tracking\u0000Text\u0001": [
	"Text"
],
	"change-tracking\u0000Paragraph\u0001": [
	"Paragraph"
],
	"change-tracking\u0000Table\u0001": [
	"Table"
],
	"change-tracking\u0000Table row\u0001": [
	"Table row"
],
	"change-tracking\u0000Table cell\u0001": [
	"Table cell"
],
	"change-tracking\u0000Text frame\u0001": [
	"Text frame"
],
	"change-tracking\u0000Shape\u0001": [
	"Shape"
],
	"change-tracking\u0000Drawing\u0001": [
	"Drawing"
],
	"\u0000Unknown\u0001": [
	"Unknown"
],
	"\u0000Change tracking\u0001": [
	"Change tracking"
],
	"\u0000Accept this change in the document\u0001": [
	"Accept this change in the document"
],
	"\u0000Reject\u0001": [
	"Reject"
],
	"\u0000Reject this change in the document\u0001": [
	"Reject this change in the document"
],
	"\u0000Show\u0001": [
	"Show"
],
	"\u0000Show this change in the document\u0001": [
	"Show this change in the document"
],
	"\u0000Custom\u0001": [
	"Custom"
],
	"\u0000Update this date field automatically on document load, download and mail\u0001": [
	"Update this date field automatically on document load, download and e-mail"
],
	"\u0000Set to today\u0001": [
	"Set to today"
],
	"\u0000Set to today's date\u0001": [
	"Set to today's date"
],
	"\u0000Pick date\u0001": [
	"Pick date"
],
	"\u0000Edit field\u0001": [
	"Edit field"
],
	"\u0000Field formatting\u0001": [
	"Field formatting"
],
	"\u0000Select format\u0001": [
	"Select format"
],
	"\u0000Change date\u0001": [
	"Change date"
],
	"\u0000Paragraph formatting\u0001": [
	"Paragraph formatting"
],
	"\u0000Yesterday\u0001": [
	"Yesterday"
],
	"\u0000Show ruler\u0001": [
	"Show ruler"
],
	"\u0000Toggle ruler next to document\u0001": [
	"Toggle ruler next to document"
],
	"\u0000Line break\u0001": [
	"Line break"
],
	"\u0000Insert line break\u0001": [
	"Insert line break"
],
	"\u0000Page break\u0001": [
	"Page break"
],
	"\u0000Insert page break\u0001": [
	"Insert page break"
],
	"\u0000Split table\u0001": [
	"Split table"
],
	"\u0000Turn automatic height resizing of text frames on or off\u0001": [
	"Turn automatic height resizing of text frames on or off"
],
	"\u0000On\u0001": [
	"On"
],
	"\u0000Track changes\u0001": [
	"Track changes"
],
	"\u0000Turn change tracking on or off\u0001": [
	"Turn change tracking on or off"
],
	"\u0000Accept the current change and select the next change\u0001": [
	"Accept the current change and select the next change"
],
	"\u0000Reject the current change and select the next change\u0001": [
	"Reject the current change and select the next change"
],
	"\u0000Accept the current change\u0001": [
	"Accept the current change"
],
	"\u0000Reject the current change\u0001": [
	"Reject the current change"
],
	"\u0000Previous\u0001": [
	"Previous"
],
	"\u0000Select the previous change in the document\u0001": [
	"Select the previous change in the document"
],
	"\u0000Next\u0001": [
	"Next"
],
	"\u0000Select the next change in the document\u0001": [
	"Select the next change in the document"
],
	"\u0000Select the previous comment in the document\u0001": [
	"Select the previous comment in the document"
],
	"\u0000Select the next comment in the document\u0001": [
	"Select the next comment in the document"
],
	"\u0000Delete all\u0001": [
	"Delete all"
],
	"\u0000Delete all comments\u0001": [
	"Delete all comments"
],
	"\u0000There are no tracked changes in your document.\u0001": [
	"There are no tracked changes in your document."
],
	"\u0000No table of contents entries in the document.\u0001": [
	"No table of contents entries in the document."
],
	"\u0000Contents\u0001": [
	"Contents"
],
	"\u0000Preparing Table of contents.\u0001": [
	"Preparing Table of contents."
],
	"\u0000Updating Table of contents will take some time, please wait...\u0001": [
	"Updating Table of contents will take some time, please wait..."
],
	"\u0000Contents heading\u0001": [
	"Contents heading"
],
	"\u0000Table of contents\u0001": [
	"Table of contents"
],
	"\u0000Inserting Table of contents will take some time, please wait...\u0001": [
	"Inserting Table of contents will take some time, please wait..."
],
	"\u0000lowercase\u0001": [
	"lowercase"
],
	"\u0000UPPERCASE\u0001": [
	"UPPERCASE"
],
	"\u0000First capital\u0001": [
	"First capital"
],
	"\u0000Title Case\u0001": [
	"Title Case"
],
	"\u0000hexadecimal\u0001": [
	"hexadecimal"
],
	"\u0000Table of Contents. Right click...\u0001": [
	"Table of Contents. Right click..."
],
	"\u0000Updating all fields in document will take some time.\u0001": [
	"Updating all fields in the document will take some time."
],
	"\u0000Header\u0001": [
	"Header"
],
	"\u0000Odd header\u0001": [
	"Odd header"
],
	"\u0000Odd footer\u0001": [
	"Odd footer"
],
	"\u0000First header\u0001": [
	"First header"
],
	"\u0000First footer\u0001": [
	"First footer"
],
	"\u0000Even header\u0001": [
	"Even header"
],
	"\u0000Even footer\u0001": [
	"Even footer"
],
	"\u0000Go to footer\u0001": [
	"Go to footer"
],
	"\u0000Go to header\u0001": [
	"Go to header"
],
	"\u0000Replacing text.\u0001": [
	"Replacing text."
],
	"\u0000No search result found.\u0001": [
	"No search results found."
],
	"\u0000This document contains text in languages which could not be proofed: %1$s\u0001": [
	"This document contains text in languages which could not be proofed: %1$s"
],
	"\u0000Set language notification.\u0001": [
	"Set language notification."
],
	"\u0000Sorry, formatting content will take some time.\u0001": [
	"Sorry, formatting content will take some time."
],
	"\u0000The selected text is very long. It will take some time to be copied. Do you really want to continue?\u0001": [
	"The selected text is very long. It will take some time to be copied. Do you really want to continue?"
],
	"\u0000Pasting shapes into comments is not supported.\u0001": [
	"Pasting shapes into comments is not supported."
],
	"\u0000Pasting shapes into text frames is not supported.\u0001": [
	"Pasting shapes into text frames is not supported."
],
	"\u0000Pasting content into this object is not supported.\u0001": [
	"Pasting content into this object is not supported."
],
	"\u0000Pasting fields into comments is not supported.\u0001": [
	"Pasting fields into comments is not supported."
],
	"\u0000Pasting lists into comments is not supported.\u0001": [
	"Pasting lists into comments is not supported."
],
	"\u0000Pasting groups with tables is not supported.\u0001": [
	"Pasting groups with tables is not supported."
],
	"\u0000Sorry, pasting from clipboard will take some time.\u0001": [
	"Sorry, pasting from the clipboard will take some time."
],
	"\u0000Sorry, pasting slides from clipboard will take some time.\u0001": [
	"Sorry, pasting slides from clipboard will take some time."
],
	"\u0000Sorry, deleting content will take some time.\u0001": [
	"Sorry, deleting content will take some time."
],
	"\u0000Sorry, applying changes will take some time.\u0001": [
	"Sorry, applying changes will take some time."
],
	"\u0000Black diamond\u0001": [
	"Black diamond"
],
	"\u0000Arrow head\u0001": [
	"Arrow head"
],
	"\u0000Check mark\u0001": [
	"Check mark"
],
	"\u0000This table is too large to be displayed here.\u0001": [
	"This table is too large to be displayed here."
],
	"\u0000The table contains %1$d row.\u0001This table contains %1$d rows.": [
	"The table contains %1$d row.",
	"This table contains %1$d rows."
],
	"\u0000Tables are limited to %1$d row.\u0001Tables are limited to %1$d rows.": [
	"Tables are limited to %1$d row.",
	"Tables are limited to %1$d rows."
],
	"\u0000The table contains %1$d column.\u0001This table contains %1$d columns.": [
	"The table contains %1$d column.",
	"This table contains %1$d columns."
],
	"\u0000Tables are limited to %1$d column.\u0001Tables are limited to %1$d columns.": [
	"Tables are limited to %1$d column.",
	"Tables are limited to %1$d columns."
],
	"\u0000The table contains %1$d cell.\u0001This table contains %1$d cells.": [
	"The table contains %1$d cell.",
	"This table contains %1$d cells."
],
	"\u0000Tables are limited to %1$d cell.\u0001Tables are limited to %1$d cells.": [
	"Tables are limited to %1$d cell.",
	"Tables are limited to %1$d cells."
],
	"drawing-pos\u0000Position\u0001": [
	"Position"
],
	"drawing-pos\u0000Drawing position\u0001": [
	"Drawing position"
],
	"drawing-pos\u0000Left aligned, no text wrapping\u0001": [
	"Left aligned, no text wrapping"
],
	"drawing-pos\u0000Left aligned, text wraps at right side\u0001": [
	"Left aligned, text wraps at right side"
],
	"drawing-pos\u0000Right aligned, no text wrapping\u0001": [
	"Right aligned, no text wrapping"
],
	"drawing-pos\u0000Right aligned, text wraps at left side\u0001": [
	"Right aligned, text wraps at left side"
],
	"drawing-pos\u0000Centered, no text wrapping\u0001": [
	"Centred, no text wrapping"
],
	"drawing-pos\u0000Centered, text wraps at left side\u0001": [
	"Centred, text wraps at left side"
],
	"drawing-pos\u0000Centered, text wraps at right side\u0001": [
	"Centred, text wraps at right side"
],
	"\u0000Bullet list\u0001": [
	"Bullet list"
],
	"\u0000Numbered list\u0001": [
	"Numbered list"
],
	"\u0000With dots and page numbers\u0001": [
	"With dots and page numbers"
],
	"\u0000With page numbers\u0001": [
	"With page numbers"
],
	"\u0000Headings only\u0001": [
	"Headings only"
],
	"\u0000Insert table of contents\u0001": [
	"Insert table of contents"
],
	"\u0000Heading %1$d\u0001": [
	"Heading %1$d"
],
	"\u0000Paragraph alignment\u0001": [
	"Paragraph alignment"
],
	"\u0000100%\u0001": [
	"100%"
],
	"\u0000115%\u0001": [
	"115%"
],
	"\u0000150%\u0001": [
	"150%"
],
	"\u0000200%\u0001": [
	"200%"
],
	"paragraph-spacing\u0000None\u0001": [
	"None"
],
	"paragraph-spacing\u0000Normal\u0001": [
	"Normal"
],
	"paragraph-spacing\u0000Wide\u0001": [
	"Wide"
],
	"\u0000Subscript\u0001": [
	"Subscript"
],
	"\u0000Superscript\u0001": [
	"Superscript"
],
	"\u0000Comment authors\u0001": [
	"Comment authors"
],
	"\u0000Show comment authors\u0001": [
	"Show comment authors"
],
	"\u0000Markup\u0001": [
	"Markup"
],
	"\u0000Highlight comments mode\u0001": [
	"Highlight comments mode"
],
	"\u0000Highlight all comments\u0001": [
	"Highlight all comments"
],
	"\u0000Highlight selected comments\u0001": [
	"Highlight selected comments"
],
	"\u0000Show bubble comments\u0001": [
	"Show bubble comments"
],
	"\u0000Show no comments\u0001": [
	"Show no comments"
],
	"drawing-pos\u0000Alignment\u0001": [
	"Alignment"
],
	"drawing-pos\u0000Drawing alignment\u0001": [
	"Drawing alignment"
],
	"drawing-pos\u0000Move with text\u0001": [
	"Move with text"
],
	"drawing-pos\u0000Move with paragraph\u0001": [
	"Move with paragraph"
],
	"drawing-pos\u0000Move with page margin\u0001": [
	"Move with page margin"
],
	"drawing-pos\u0000Move with page\u0001": [
	"Move with page"
],
	"\u0000Change style \"%1$s\"\u0001": [
	"Change style \"%1$s\""
],
	"\u0000Set image width\u0001": [
	"Set image width"
],
	"\u0000Set image height\u0001": [
	"Set image height"
],
	"\u0000Set horizontal offset\u0001": [
	"Set horizontal offset"
],
	"\u0000Set vertical offset\u0001": [
	"Set vertical offset"
],
	"\u0000Set crop position width\u0001": [
	"Set crop position width"
],
	"\u0000Set crop position height\u0001": [
	"Set crop position height"
],
	"\u0000Set left position\u0001": [
	"Set left position"
],
	"\u0000Set top position\u0001": [
	"Set top position"
],
	"\u0000Crop position\u0001": [
	"Crop position"
],
	"\u0000Image position\u0001": [
	"Image position"
],
	"\u0000Width\u0001": [
	"Width"
],
	"\u0000Height\u0001": [
	"Height"
],
	"\u0000Offset X\u0001": [
	"Offset X"
],
	"\u0000Offset Y\u0001": [
	"Offset Y"
],
	"\u0000Crop frame position\u0001": [
	"Crop frame position"
],
	"\u0000Top\u0001": [
	"Top"
],
	"\u0000Bottom\u0001": [
	"Bottom"
],
	"\u0000Paper format\u0001": [
	"Paper format"
],
	"\u0000Paper orientation\u0001": [
	"Paper orientation"
],
	"\u0000Page margins\u0001": [
	"Page margins"
],
	"\u0000Paper size\u0001": [
	"Paper size"
],
	"\u0000Slide format\u0001": [
	"Slide format"
],
	"\u0000Orientation\u0001": [
	"Orientation"
],
	"\u0000Slide size\u0001": [
	"Slide size"
],
	"\u0000Tabloid\u0001": [
	"Tabloid"
],
	"\u0000Legal\u0001": [
	"Legal"
],
	"\u0000Statement\u0001": [
	"Statement"
],
	"\u0000Executive\u0001": [
	"Executive"
],
	"\u0000Folio\u0001": [
	"Folio"
],
	"\u0000A3\u0001": [
	"A3"
],
	"\u0000A4\u0001": [
	"A4"
],
	"\u0000A5\u0001": [
	"A5"
],
	"\u0000B4\u0001": [
	"B4"
],
	"\u0000B5\u0001": [
	"B5"
],
	"\u0000Standard (4:3)\u0001": [
	"Standard (4:3)"
],
	"\u0000Widescreen (16:9)\u0001": [
	"Widescreen (16:9)"
],
	"\u0000Widescreen (16:10)\u0001": [
	"Widescreen (16:10)"
],
	"\u0000Widescreen HD (16:9)\u0001": [
	"Widescreen HD (16:9)"
],
	"\u0000Portrait\u0001": [
	"Portrait"
],
	"\u0000Landscape\u0001": [
	"Landscape"
],
	"\u0000Narrow\u0001": [
	"Narrow"
],
	"\u0000Normal\u0001": [
	"Normal"
],
	"\u0000Wide\u0001": [
	"Wide"
],
	"\u0000Invalid name for a paragraph style.\u0001": [
	"Invalid name for a paragraph style."
],
	"\u0000Paragraph style \"%1$s\" exists already.\u0001": [
	"Paragraph style \"%1$s\" exists already."
],
	"\u0000More font styles\u0001": [
	"More font styles"
],
	"\u0000Text alignment\u0001": [
	"Text alignment"
],
	"\u0000Align text vertically inside textbox\u0001": [
	"Align text vertically inside textbox"
],
	"\u0000Align text horizontally and vertically inside textbox\u0001": [
	"Align text horizontally and vertically inside textbox"
],
	"\u0000Text position\u0001": [
	"Text position"
],
	"\u0000Line spacing\u0001": [
	"Line spacing"
],
	"\u0000Paragraph spacing\u0001": [
	"Paragraph spacing"
],
	"\u0000Paragraph & Line spacing\u0001": [
	"Paragraph & Line spacing"
],
	"\u0000Middle\u0001": [
	"Middle"
],
	"\u0000Follow anchor link\u0001": [
	"Follow anchor link"
],
	"\u0000Click to go to this paragraph in document\u0001": [
	"Click to go to this paragraph in document"
],
	"\u0000Show alignment guides\u0001": [
	"Show alignment guides"
],
	"\u0000Show or hide alignment guides on shape move or resize\u0001": [
	"Show or hide alignment guides on shape move or resize"
],
	"\u0000Accept and next\u0001": [
	"Accept and next"
],
	"\u0000Accept this change\u0001": [
	"Accept this change"
],
	"\u0000Accept all changes\u0001": [
	"Accept all changes"
],
	"\u0000Accept all changes in the document\u0001": [
	"Accept all changes in the document"
],
	"\u0000Reject and next\u0001": [
	"Reject and next"
],
	"\u0000Reject this change\u0001": [
	"Reject this change"
],
	"\u0000Reject all changes\u0001": [
	"Reject all changes"
],
	"\u0000Reject all changes in the document\u0001": [
	"Reject all changes in the document"
],
	"\u0000Paragraph style\u0001": [
	"Paragraph style"
],
	"\u0000Apply style\u0001": [
	"Apply style"
],
	"\u0000Update style\u0001": [
	"Update style"
],
	"\u0000Update current style from selection\u0001": [
	"Update current style from selection"
],
	"\u0000Rename style\u0001": [
	"Rename style"
],
	"\u0000Delete style\u0001": [
	"Delete style"
],
	"\u0000Create new style\u0001": [
	"Create new style"
],
	"\u0000Create new style from selection\u0001": [
	"Create new style from selection"
],
	"\u0000Format painter\u0001": [
	"Format painter"
],
	"\u0000Edit field format\u0001": [
	"Edit field format"
],
	"\u0000Edit format of selected field\u0001": [
	"Edit format of selected field"
],
	"\u0000Update field\u0001": [
	"Update field"
],
	"\u0000Update selected field\u0001": [
	"Update selected field"
],
	"\u0000Update all fields\u0001": [
	"Update all fields"
],
	"\u0000Update all fields in document\u0001": [
	"Update all fields in document"
],
	"\u0000Insert current slide number\u0001": [
	"Insert current slide number"
],
	"\u0000Insert current date and time\u0001": [
	"Insert current date and time"
],
	"\u0000Insert footer with fields like date and slide number\u0001": [
	"Insert footer with fields like date and slide number"
],
	"\u0000Ignore all\u0001": [
	"Ignore all"
],
	"\u0000Add to dictionary\u0001": [
	"Add to dictionary"
],
	"\u0000Start list with first value\u0001": [
	"Start list with first value"
],
	"\u0000Continue list numbering\u0001": [
	"Continue list numbering"
],
	"\u0000Table of contents layouts\u0001": [
	"Table of contents layouts"
],
	"\u0000Change current layout\u0001": [
	"Change current layout"
],
	"\u0000Delete table\u0001": [
	"Delete table"
],
	"\u0000Text highlight color\u0001": [
	"Text highlight colour"
],
	"\u0000Colors\u0001": [
	"Colours"
],
	"\u0000Indent less\u0001": [
	"Indent less"
],
	"\u0000Indent more\u0001": [
	"Indent more"
],
	"check-list\u0000Select all\u0001": [
	"Select all"
],
	"\u0000Create folder\u0001": [
	"Create folder"
],
	"\u0000File name\u0001": [
	"File name"
],
	"\u0000OK\u0001": [
	"OK"
],
	"\u0000Close\u0001": [
	"Close"
],
	"\u0000Yes\u0001": [
	"Yes"
],
	"\u0000No\u0001": [
	"No"
],
	"language\u0000%1$s (%2$s)\u0001": [
	"%1$s (%2$s)"
],
	"\u0000Recently used\u0001": [
	"Recently used"
],
	"\u0000You do not have permissions to access the file.\u0001": [
	"You do not have permissions to access the file."
],
	"\u0000You do not have permissions to modify the file.\u0001": [
	"You do not have permissions to modify the file."
],
	"\u0000You do not have permissions to create the file.\u0001": [
	"You do not have permissions to create the file."
],
	"\u0000The file does not exist anymore. Please refresh your application.\u0001": [
	"The file no longer exists. Please refresh your application."
],
	"\u0000The folder does not exist anymore. Please refresh your application.\u0001": [
	"The folder no longer exists. Please refresh your application."
],
	"\u0000Your quota has been exceeded. Please remove files then try again.\u0001": [
	"Your quota has been exceeded. Please remove files then try again."
],
	"\u0000Editing encrypted files is currently not supported.\u0001": [
	"Editing encrypted files is currently not supported."
],
	"\u0000Failed to start application. Maybe you have connection problems. Please try again.\u0001": [
	"Failed to start application. Maybe you have connection problems. Please try again."
]
};
